// src/component/EcgPage.jsx

// 心电图展示组件
// 现用

import React from 'react'
import { DEFAULT_ZOOM, EMPTY_Y, NEW_RECORD_SYSTEM, ROLE } from '../services/Macro';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { DataApi } from '../services/Api';
import axios from 'axios';
import { strUtil } from '../utils/StrUtil';
import { mathUtil } from '../utils/MathUtil';
import { arrUtil } from '../utils/ArrUtil';
import { browserUtil } from '../utils/BrowserUtil';
import { Global } from '../services/Global';
import { componentUtil } from '../utils/ComponentUtil';
import { encrypUtil } from '../utils/EncrypUtil';
import '../css/page.ecg.css'
import { timeUtil } from '../utils/TimeUtil';

const CLS_NAME = `EcgPage`;

const NO_DELAY = false
/** 横坐标偏移量，前面空出来的区域用于绘制增益图案(3个大格) */
const TOTAL_OFF = 60
/** 一页数据的秒数 */
const SECOND_PER_PAGE = 10

/** 是否使用整数时间坐标(整秒). */
export const USE_INT_TIME = true

export default class EcgPage extends React.Component {

    state = {
        /** 画布宽度(像素) */
        canvasWidth: 1140,//1060是坐标图宽度，40*2是白边框宽度
        /** ECG画布高度(像素) */
        ecgCanvasHeight: 260,
        /** ACC画布高度(像素) */
        accCanvasHeight: 440,
        /** ACC图表高度(像素) */
        accChartHeight: 330,
        /** ACC图表Z轴负方向多余量 */
        accZPlusHeight: 30,
        /** 边框尺寸(像素) */
        frameWidth: 40,
        frameHeight: 20,
        gapHeight: 20,
        zoomX: 1,
        zoomY: 1,
        step: 0,
        /** 最大步数 */
        max: 800,
        /** 滑块标注数组 */
        marks: {},
        samplePerPage: 0,
        samplePerJumpPage: 0,
        samplePerSecond: 0,
        samplePerStep: 1,
        sampleCount: 1,

        /** 记录信息 */
        record: { nickname: "", size: 0, startTime: "00:00:00", timeLength: "00:00:00" },


        // 控制加载中的弹框
        showLoading: false,
        showAcc: false,
        blockInfo: [],
    }

    /** 每页样本数 */
    samplePerPage = 0
    /** 每翻页样本数 */
    samplePerJumpPage = 0
    /** 每秒样本数(采样频率) */
    samplePerSecond = 512
    /** 每一步的样本数 */
    samplePerStep = 1
    /** 样本数量 */
    sampleCount = 1
    /** 每秒的步数 */
    stepPerSecond = 1
    /** 每页的步数 */
    stepPerPage = 1
    /** 每页显示的秒数 */
    secondPerPage = SECOND_PER_PAGE

    /** 总的采样点数量 */
    allSampleCnt = 0
    /** 数据块数量 */
    blockCnt = 0
    /** 起始块id */
    blockIdFirst = 0
    /** 结束块id */
    blockIdLast = 0
    lackBlocks = []
    invalidBlocks = []
    leaveBlocks = []
    /** 总的记录时长 */
    totalRecordTime = 0
    /** 本地持有一个样本列表，不断随着用户的操作而远程获取数据进行填充(没有的占位数据为999999) */
    sampleList = []
    /** PACE 列表，初始化时全部设置为0, 不为0时需要画一个红色小圆圈 */
    flagList = []
    accXList = []
    accYList = []
    accZList = []
    /** IHR(Intrinsic Heart Rate) 固有心率数组，每采样一个?每分钟一个? */
    ihrList = []
    /** 心跳峰值数组，标识在第n个采样点会有一个峰值 */
    peekIndexList = []
    /** 来自服务器返回的原始数据 */
    samples = {}
    /** 当前最左侧显示的是第几秒 */
    timeSecond = 0
    /** 采样频率，次/秒 */
    rate = 512
    accRate = 25
    /** 服务器请求堆栈 */
    requestStack = []
    /** 是否请求中，如果是请求中，不应该连续发送请求 */
    isRequesting = false
    /** 使用者信息 */
    userInfo = []
    /** 设备信息 */
    deviceInfo = []
    /** 数据信息 */
    dataInfo = []
    headerSize = 645
    /** ACC数值与幂=8时的倍数 */
    gn8Rate = 1
    /** 记录开始的时间戳，单位是秒 */
    startTime = 0

    componentWillMount() {
        const DEBUG = true
        const TAG = `EcgPage.componentWillMount() - `
        // 组件挂载前获取的屏幕尺寸真实可信
        Global.windowWidth = window.innerWidth
        DEBUG && console.log(TAG, `windowWidth:`, Global.windowWidth)
        Global.isMobile = browserUtil.checkMobile()
        if (Global.isMobile) {
            this.state.canvasWidth = Global.windowWidth
            this.setState({ canvasWidth: this.state.canvasWidth })
            DEBUG && console.log(TAG, `this.state.canvasWidth:`, this.state.canvasWidth)
            if (Global.isMobile) {
                this.state.frameWidth = 50
                this.setState({ frameWidth: this.state.frameWidth })
            }
            this.state.max = this.state.canvasWidth - 100
            this.setState({ max: this.state.max })
        }
    }

    componentDidMount() {
        this.props.onRef(this)
        this.callDrawFromChild()
        this.requestInfo()
    }

    /** 请求该 ECG 数据的用户信息，数据块信息. */
    requestInfo = async () => {
        const TAG = `EcgPage.requestInfo() - `
        let t = this.props.trans
        let token = localStorage.getItem('token') || null
        let lang = localStorage.getItem('lang') || 'zh_CN'
        const searchParams = new URLSearchParams(window.location.search)
        const url = searchParams.get('url')
        let requestData = {
            role: ROLE.SUPER,
            token: token,
            url: url,
            lang: lang.split('_')[0],
        }
        if (NEW_RECORD_SYSTEM) requestData.newRecord = true
        let params = await encrypUtil.encodeRequestRsa(requestData)
        const response = await axios.post(DataApi.GET_RECORD_INFO, params)
        let retData = response.data.data
        // console.log(TAG, `获取心电图信息:\n`, retData)
        let record = retData.record

        record.create = strUtil.formatTime(record.create)
        // console.log(TAG, `meta:\n`, record.meta)
        record.rate = record.meta.rate || 512
        record.size = strUtil.toM(record.size)
        record.timeLength = '00:00:00'
        record.nickname = ''
        if (record.meta) {
            if (record.meta.gn) this.gn8Rate = Math.pow(2, record.meta.gn - 8)
            if (record.meta.timeLength) record.timeLength = strUtil.formatDuration(record.meta.timeLength)
            if (record.meta.name) record.nickname = record.meta.name
            if (record.meta.startTime) {
                this.startTime = record.meta.startTime
                record.startTime = strUtil.formatTime(record.meta.startTime * 1000)
            }
            if (record.meta.firmwareVersion) {
                // console.log(TAG, `firmwareVersion:`, record.meta.firmwareVersion)
                let infoList = record.meta.firmwareVersion.split('_')
                let versionType = infoList[0]
                record.firmwareType = versionType
                let versionStr = infoList[2]
                // console.log(TAG, `versionType:`, versionType)
                // console.log(TAG, `versionStr:`, versionStr)
                // console.log(TAG, `parseInt(versionStr):`, parseInt(versionStr))
                if (versionType == 'CA' && parseInt(versionStr) >= 2) {
                    this.gn8Rate = Math.pow(2, 13 - 8)
                }
                else if (versionType == 'CB' && parseInt(versionStr) >= 5) {
                    this.gn8Rate = Math.pow(2, 13 - 8)
                }
            }
        }

        let blockInfo = retData.blockInfo
        if (blockInfo) {
            this.allSampleCnt = blockInfo.allSampleCnt
            this.blockCnt = blockInfo.blockCount
            this.blockIdFirst = blockInfo.blockIdFirst
            this.blockIdLast = blockInfo.blockIdLast
            this.lackBlocks = blockInfo.lackBlocks
            this.invalidBlocks = blockInfo.invalidBlocks
            this.leaveBlocks = blockInfo.leaveBlocks
        }

        // console.log(TAG, `record:\n`, record)
        this.state.record = record
        this.setState({ record: record })

        this.userInfo = [
            {
                key: t('nickname'),
                val: record.nickname
            },
            {
                key: t('terminalType'),
                val: Global.isMobile ? t('mobileTerminal') : t('pcTerminal')
            },
        ]

        this.deviceInfo = [
            {
                key: 'MAC',
                val: record.device
            },
            {
                key: t('firmwareType'),
                val: record.firmwareType
            },
        ]

        this.dataInfo = [
            {
                key: t('size'),
                val: record.size
            },
            {
                key: t('startTime'),
                val: record.startTime
            },
            {
                key: t('timeLength'),
                val: record.timeLength
            },
            {
                key: t('sampleRate'),
                val: record.rate
            },
            {
                key: t('url'),
                val: url
            },
        ]

        const blockInfoData = [
            {
                key: t('blockCnt'),
                val: this.blockCnt
            },
            {
                key: t('blockIdFirst'),
                val: this.blockIdFirst
            },
            {
                key: t('blockIdLast'),
                val: this.blockIdLast
            },
            {
                key: t('lackBlock'),
                val: this.lackBlocks.length == 0 ? t('none') :
                    this.lackBlocks.length > 10 ?
                        this.lackBlocks.slice(0, 10).join(', ') + `... remain ${this.lackBlocks.length - 10} blocks missing`
                        : this.lackBlocks.slice(0, 10).join(', ')
            },
            {
                key: t('invalidBlock'),
                val: this.invalidBlocks.length == 0 ? t('none') :
                    this.invalidBlocks.length > 10 ?
                        this.invalidBlocks.slice(0, 10).join(', ') + `... remain ${this.invalidBlocks.length - 10} blocks invalid`
                        : this.invalidBlocks.slice(0, 10).join(', ')
            },
            // 展示id=0的数据块索引列表
            {
                key: t('leaveBlockCnt'),
                val: this.leaveBlocks.length
            },
            {
                key: t('hasAcc'),
                val: this.state.showAcc ? t('yes') : t('none')
            },
        ];
        this.setState({ blockInfo: blockInfoData });
    }

    /** 向服务器请求图表数据.
     * @param {*} startTime 
     */
    requestData = async (startTime) => {
        this.isRequesting = true
        // 显示加载中
        this.showLoading()
        let token = localStorage.getItem('token') || null
        let lang = localStorage.getItem('lang') || 'zh_CN'
        const searchParams = new URLSearchParams(window.location.search)
        const url = searchParams.get('url')
        const response = await axios.post(DataApi.GET_RECORD_CHART, {
            role: ROLE.SUPER,
            token: token,
            url: url,
            lang: lang.split('_')[0],
            startTime: startTime,
            timeLength: 32,
            parseInChildProcess: true,
        })
        let retData = response.data.data
        // console.log(`获取心电图数据:\n`, retData)
        this.samples = retData
        // 关闭加载中
        this.closeLoading()
        this.isRequesting = false
    }

    /** 尝试从服务器获取数据
     * @param {*} forward 是否向前翻看
     */
    tryGetDataFromServer = async (forward) => {
        const TAG = `EcgPage.tryGetDataFromServer() - `
        let startPointIdx = this.timeSecond * this.rate
        let endPointIdx = startPointIdx + this.rate * (this.secondPerPage + 1)
        if (endPointIdx > this.allSampleCnt - 1) endPointIdx = this.allSampleCnt - 1
        let needRequest = false
        console.log(TAG, `startPointIdx:`, startPointIdx)
        console.log(TAG, `endPointIdx:`, endPointIdx)
        console.log(TAG, `this.state.showAcc:`, this.state.showAcc)
        let requestSecond = this.timeSecond
        if (forward) {
            for (let i = startPointIdx; i < endPointIdx; i++) {
                if (this.state.showAcc) {// ACC 数据会滞后，所以向前翻看时需要往前看 headerSize 个数据是否为空
                    let idx = Math.max(i - this.headerSize, 0)
                    // console.log(TAG, `this.accXList[${idx}]:`, this.accXList[idx])
                    let accEmpty = this.accXList[idx] == EMPTY_Y
                    if (accEmpty) {
                        console.log(TAG, `已经没有ACC数据了: ${idx}`)
                        needRequest = true
                        requestSecond = Math.floor(idx / this.rate)
                        this.requestStack.push(requestSecond)
                        break
                    }
                }
                let sampleEmpty = this.sampleList[i] == EMPTY_Y // 数据列表中有未赋值的数据
                if (sampleEmpty) {
                    console.log(TAG, `已经没有ECG数据了: ${i}`)
                    needRequest = true
                    requestSecond = Math.floor(i / this.rate)
                    this.requestStack.push(requestSecond)
                    break
                }
            }
        }
        else {
            for (let i = startPointIdx; i < endPointIdx; i++) {
                let sampleEmpty = this.sampleList[i] == EMPTY_Y // 数据列表中有未赋值的数据
                if (sampleEmpty) {
                    console.log(TAG, `已经没有ECG数据了: ${i}`)
                    needRequest = true
                    requestSecond = Math.floor(i / this.rate)
                    this.requestStack.push(requestSecond)
                    break
                }
                if (this.state.showAcc) {// ACC 数据会滞后，所以向前翻看时需要往前看 headerSize 个数据是否为空
                    let idx = Math.max(i - this.headerSize, 0)
                    // console.log(TAG, `this.accXList[${idx}]:`, this.accXList[idx])
                    let accEmpty = this.accXList[idx] == EMPTY_Y
                    if (accEmpty) {
                        console.log(TAG, `已经没有ACC数据了: ${idx}`)
                        needRequest = true
                        requestSecond = Math.floor(idx / this.rate)
                        this.requestStack.push(requestSecond)
                        break
                    }
                }
            }
        }
        if (needRequest) {
            while (this.requestStack.length > 0 && !this.isRequesting) {
                requestSecond = this.requestStack.pop()
                this.requestStack = []
                console.log(TAG, `向服务器请求数据: ${requestSecond}`)
                await this.requestData(requestSecond)
            }
        }
    }

    // =============================================================================
    // 导航ECG时间轴后的数据处理(翻页，跳秒，拖动)
    // =============================================================================

    /** 处理拖动后的ECG数据请求 */
    handleChange = async (step) => {
        const DEBUG = true
        const TAG = `EcgPage.handleChange() - `
        DEBUG && console.log(TAG, `step(步数)(ori):`, step)
        if (USE_INT_TIME) {
            step = Math.round(step / this.stepPerSecond) * this.stepPerSecond
        }
        DEBUG && console.log(TAG, `step(步数)(int):`, step)
        const targetSampleCnt = this.state.samplePerStep * step
        this.timeSecond = Math.floor(targetSampleCnt / this.state.samplePerSecond)
        DEBUG && console.log(TAG, `timeSecond:`, this.timeSecond)
        if (this.timeSecond < 0) this.timeSecond = 0
        if (this.timeSecond > this.totalRecordTime - 1)
            this.timeSecond = this.totalRecordTime - 1

        // 限定当前步数
        // if (step > this.state.max) step = this.state.max
        this.state.step = step
        this.setState({ step })
        this.draw()
        await this.tryGetDataFromServer(true)
        this.draw()
    }

    /** 向前跳1秒 */
    prevSecond = async () => {
        console.log(`Click prevSecond...`)
        const TAG = `EcgPage.prevSecond() - `
        this.timeSecond--
        if (this.timeSecond < 0) this.timeSecond = 0
        // this.state.step -= (this.state.samplePerSecond / this.state.samplePerStep)
        this.state.step -= this.stepPerSecond
        if (this.state.step < 0) this.state.step = 0
        console.log(TAG, `new step:`, this.state.step)
        this.setState({ step: this.state.step })

        this.draw()
        await this.tryGetDataFromServer(true)
        this.draw()
    }

    /** 向后跳1秒 */
    nextSecond = async () => {
        console.log(`Click nextSecond...`)
        const TAG = `EcgPage.nextSecond() - `
        this.timeSecond++
        // this.state.step += (this.state.samplePerSecond / this.state.samplePerStep)
        this.state.step += this.stepPerSecond
        this.checkEnd()
        this.draw()
        await this.tryGetDataFromServer(false)
        this.draw()
    }

    /** 翻页或跳秒后检查是否已经到达ECG图表的最后位置. */
    checkEnd = () => {
        const TAG = `EcgPage.checkEnd() - `
        // let stepPerPage = this.state.samplePerJumpPage / this.state.samplePerStep
        if (this.timeSecond > this.totalRecordTime - 10) this.timeSecond = this.totalRecordTime - 10
        if (this.state.step > this.state.max - this.stepPerPage) this.state.step = this.state.max - this.stepPerPage
        console.log(TAG, `new step:`, this.state.step)
        this.setState({ step: this.state.step })
    }

    /** 向前翻一页 */
    prevPage = async () => {
        console.log(`Click prevPage...`)
        this.timeSecond -= this.secondPerPage
        // this.state.step -= (this.state.samplePerJumpPage / this.state.samplePerStep)
        this.state.step -= this.stepPerPage
        if (this.state.step < 0) this.state.step = 0
        console.log(`new step:`, this.state.step)
        this.setState({ step: this.state.step });
        this.draw()
        await this.tryGetDataFromServer(true)
        this.draw()
    }

    /** 向后翻一页 */
    nextPage = async () => {
        console.log(`Click nextPage...`)
        // let stepPerPage = this.state.samplePerJumpPage / this.state.samplePerStep
        this.timeSecond += this.secondPerPage
        this.state.step += this.stepPerPage
        this.checkEnd()
        this.draw()
        await this.tryGetDataFromServer(false)
        this.draw()
    }

    /** 跳转到第一页 */
    firstPage = async () => {
        console.log(`Click firstPage...`)
        this.timeSecond = 0
        this.state.step = 0
        console.log(`new step:`, this.state.step)
        this.setState({ step: this.state.step });
        this.draw()
        await this.tryGetDataFromServer(true)
        this.draw()
    }

    /** 跳转到最后一页 */
    lastPage = async () => {
        console.log(`Click lastPage...`)
        this.timeSecond = this.totalRecordTime//this.secondPerPage
        if (USE_INT_TIME) {
            this.timeSecond = Math.round(this.timeSecond)
        }
        console.log(`this.timeSecond:`, this.timeSecond)
        let step = this.state.sampleCount / this.state.samplePerStep
        if (USE_INT_TIME) {
            this.state.step = Math.round(step / this.stepPerSecond) * this.stepPerSecond
        }
        else {
            this.state.step = step
        }
        if (this.state.step > this.state.max) this.state.step = this.state.max
        console.log(`this.state.step:`, this.state.step)
        this.checkEnd()
        this.draw()
        await this.tryGetDataFromServer(false)
        this.draw()
    }

    /** 父组件调用 showLoading() */
    callShowLoadingFromParent() {
        this.showLoading()
    }

    /** 父组件调用 closeLoading() */
    callCloseLoadingFromParent() {
        this.closeLoading()
    }

    /** 显示"加载中..." */
    showLoading = () => {
        this.state.showLoading = true
        this.setState({ showLoading: this.state.showLoading })
    }

    /** 关闭"加载中..." */
    closeLoading = () => {
        this.state.showLoading = false
        this.setState({ showLoading: this.state.showLoading })
    }

    /** 父组件调用 draw() */
    callDrawFromParent() {
        if (this.props.samples) {
            if (this.props.samples.data1) {
                this.samples = this.props.samples
                this.draw()
            }
            else {
                // 第一次调用时没有数据，需要等一下(0.01s)
                setTimeout(() => {
                    this.callDrawFromParent()
                }, 10)
            }
        }
    }

    /** 子组件调用 draw() */
    callDrawFromChild() {
        this.samples = this.props.samples
        this.draw()
    }

    /** 设置 ACC 数据(跳过滞后长度) */
    setAccData = (remoteStartPoint, accList, acc) => {
        let cnt = remoteStartPoint
        for (let i = 0; i < acc.length; i++) {
            const block = acc[i]
            const largeBlock = mathUtil.large(block, 4000)
            for (let j = 0; j < largeBlock.length; j++) {
                let accVal = largeBlock[j] / this.gn8Rate
                accList[cnt + this.headerSize] = accVal
                cnt++
            }
        }
    }

    /** 设置 HRV 数据(每个数据块(500采样)一个数据) */
    setHrvData = (startIdx, hrvData) => {
        const TAG = `EcgPage.setHrvData() -`
        const DEBUG = false
        DEBUG && console.log(TAG, `hrvData.length:`, hrvData.length)
        for (let i = 0; i < hrvData.length; i++) {
            const hrv = hrvData[i]
            // console.log(TAG, `[${i}]hrv.ihr:`, hrv.ihr)
            // for (let j = 0; j < hrv.ihr.length; j++) {
            //     this.ihrList.push(hrv.ihr[j])
            // }
            DEBUG && console.log(TAG, `[${i}]hrv.peekIndex:`, hrv.peekIndex)
            for (let j = 0; j < hrv.peekIndex.length; j++) {
                const e = hrv.peekIndex[j]
                if (!this.peekIndexList.includes(e)) {
                    this.peekIndexList.push(e)
                }
            }
        }
        // peekIndexList 去重，排序
        this.peekIndexList = arrUtil.unique(this.peekIndexList)
        this.peekIndexList = arrUtil.sort(this.peekIndexList)
        // console.log(TAG, `ihrList:\n`, this.ihrList)
        DEBUG && console.log(TAG, `peekIndexList:\n`, this.peekIndexList)
    }

    /** 绘制图表 */
    draw() {
        let t = this.props.trans;

        if (this.samples && this.samples.hasAcc) {
            this.state.showAcc = true;
            this.setState({ showAcc: true });
            for (let i = 0; i < this.state.blockInfo.length; i++) {
                const info = this.state.blockInfo[i];
                if (info.key == t('hasAcc')) {
                    info.val = t('yes');
                    break;
                }
            }
            this.setState({ blockInfo: this.state.blockInfo });
        }
        if (Global.isMobile) {
            this.state.showAcc && this.drawAccChart2Mobile()
            this.drawEcgChartMobile()
        }
        else {
            this.state.showAcc && this.drawAccChart2Pc()
            this.drawEcgChartPc()
        }
    }

    /** 绘制 ACC 线条 */
    drawAccLine(ctx, color, accList, baseY, startSample, endSample, samplePerPixel) {
        const { zoomX, frameWidth } = this.state
        const scale = 4
        ctx.fillStyle = color
        ctx.strokeStyle = color
        let data = accList.slice(startSample, endSample)
        for (let i = 0; i < data.length - 1; i++) {
            if (data[i] != EMPTY_Y && data[i + 1] != EMPTY_Y) {
                let x1 = i * zoomX / samplePerPixel + frameWidth
                let y1 = baseY - data[i] * this.state.zoomY / scale
                let x2 = (i + 1) * zoomX / samplePerPixel + frameWidth
                let y2 = baseY - data[i + 1] * this.state.zoomY / scale
                this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, 1 * zoomX)
            }
        }
    }

    /** 绘制 ACC 线条 */
    drawAccLine2(ctx, color, accList, baseY, startSample, endSample, samplePerPixel, coorMin, canvasRange) {
        const { zoomX, frameWidth } = this.state
        ctx.fillStyle = color
        ctx.strokeStyle = color
        let data = accList.slice(startSample, endSample + (NO_DELAY ? this.headerSize : 0))
        for (let i = 0; i < data.length - 1; i++) {
            let dataIdx = i + (NO_DELAY ? this.headerSize : 0)
            if (dataIdx > data.length - 1) break
            if (data[dataIdx] != EMPTY_Y && data[dataIdx + 1] != EMPTY_Y) {
                let x1 = i * zoomX / samplePerPixel + frameWidth + TOTAL_OFF
                let x2 = (i + 1) * zoomX / samplePerPixel + frameWidth + TOTAL_OFF
                let y1 = baseY * 2 - ((data[dataIdx] - coorMin) / canvasRange * 120 + baseY - 60)
                let y2 = baseY * 2 - ((data[dataIdx + 1] - coorMin) / canvasRange * 120 + baseY - 60)
                // if (i == data.length - 10) console.log(TAG, `y1:${y1}, y2: ${y2}`)
                if (y1 > baseY - 60 && y1 < baseY + 60 && y2 > baseY - 60 && y2 < baseY + 60) {
                    this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, 1)
                }
            }
        }
    }

    /** 绘制 ACC 图表(XYZ分开，并仅显示有效区域)(移动端) */
    drawAccChart2Mobile() {
        const DEBUG = false
        const TAG = `EcgPage.drawAccChart2Mobile() - `
        const { zoomX, zoomY, frameWidth, frameHeight, canvasWidth, accCanvasHeight, gapHeight, accChartHeight, accZPlusHeight } = this.state
        let canvas = document.getElementById('acc')
        if (!canvas.getContext) return
        var ctx = canvas.getContext("2d")

        const scale = 4
        // 计算采样显示相关数据
        let baseYX = 0
        let baseYY = 0
        let baseYZ = 0
        let samplePerPage = 0
        let sampleCount = 0
        let samplePerPixel = 1
        let samplePerStep = 0
        let durationPerStep = 0
        let startSample = 0
        let endSample = 0
        /** 列偏移量 */
        let colOffset = 0
        let xAnnotations = []
        if (this.samples) {
            if (this.samples.data1) {
                if (this.sampleList.length == 0) {
                    for (let i = 0; i < this.allSampleCnt; i++) {
                        this.sampleList.push(EMPTY_Y)
                    }
                }
                if (this.accXList.length == 0) {
                    for (let i = 0; i < this.headerSize; i++) {
                        this.accXList.push(0)
                    }
                    for (let i = 0; i < this.allSampleCnt; i++) {
                        this.accXList.push(EMPTY_Y)
                    }
                }
                if (this.accYList.length == 0) {
                    for (let i = 0; i < this.headerSize; i++) {
                        this.accYList.push(0)
                    }
                    for (let i = 0; i < this.allSampleCnt; i++) {
                        this.accYList.push(EMPTY_Y)
                    }
                }
                if (this.accZList.length == 0) {
                    for (let i = 0; i < this.headerSize; i++) {
                        this.accZList.push(0)
                    }
                    for (let i = 0; i < this.allSampleCnt; i++) {
                        this.accZList.push(EMPTY_Y)
                    }
                }
                this.rate = this.samples.data1.rate// 采样频率(个/秒)
                this.totalRecordTime = Math.ceil(this.allSampleCnt / this.rate)
                console.log(TAG, `记录总时长 totalRecordTime: ${this.totalRecordTime}秒`)
                let remoteStartPoint = this.samples.data1.startPoint// 返回数据的第一个在总数据中的索引
                let remoteList = this.samples.data1.list
                let remoteEndPoint = remoteStartPoint + remoteList.length
                // console.log(TAG, `remoteStartPoint:`, remoteStartPoint)
                // console.log(TAG, `remoteEndPoint:`, remoteEndPoint)
                for (let i = remoteStartPoint; i < remoteEndPoint; i++) {
                    this.sampleList[i] = remoteList[i - remoteStartPoint]
                }
                samplePerPixel = this.rate / 100
                sampleCount = this.sampleList.length
                // console.log(TAG, `sampleCount:`, sampleCount)
                samplePerStep = sampleCount / this.state.max
                durationPerStep = samplePerStep / this.rate
                // 开始采样点
                startSample = Math.round(this.state.step * samplePerStep)
                let sampleOffset = this.rate - (startSample % this.rate)
                if (sampleOffset == this.rate) sampleOffset = 0
                colOffset = 100 * sampleOffset / 512 * zoomX
                // colOffset = (startSample * 10 % (this.rate * 10 / 5)) * 5 / (this.rate * 10 / 5) * 4 * zoomX
                // console.log(TAG, `startSample:`, startSample)
                // console.log(TAG, `rate:`, this.rate)
                // console.log(TAG, `colOffset:`, colOffset)
                for (let i = 0; i < 11; i++) {
                    const x = colOffset + i * 4 * zoomX * 25 + frameWidth
                    const sampleCount = Math.round(startSample + i * this.rate)
                    const sampleSecond = Math.round(sampleCount / this.rate)
                    // const text = `${sampleCount}p`// 采样点数
                    // const text = `${sampleSecond}s`// 秒
                    const text = `${strUtil.formatDuration(sampleSecond)}`// 00:00:00
                    // console.log(`x:`, x)
                    // console.log(`text:`, text)
                    xAnnotations.push({ x: x, text: text })
                }

                this.state.samplePerSecond = this.rate
                this.setState({ samplePerSecond: this.state.samplePerSecond })
                this.state.samplePerJumpPage = this.rate * Math.floor(10 / zoomX)// 一页为10秒数据
                this.setState({ samplePerJumpPage: this.state.samplePerJumpPage })
                this.state.samplePerStep = samplePerStep
                this.setState({ samplePerStep: this.state.samplePerStep })
                this.state.sampleCount = sampleCount
                this.setState({ sampleCount: this.state.sampleCount })
            }
            if (this.samples.data2) {
                this.accRate = this.samples.data2.rate// 采样频率(个/秒)
                let accX = this.samples.data2.accX
                let accY = this.samples.data2.accY
                let accZ = this.samples.data2.accZ

                let remoteStartPoint = this.samples.data1.startPoint
                let blockStartId = Math.floor(remoteStartPoint / 4000)
                // console.log(`blockStartId:`, blockStartId)
                this.setAccData(remoteStartPoint, this.accXList, accX)
                this.setAccData(remoteStartPoint, this.accYList, accY)
                this.setAccData(remoteStartPoint, this.accZList, accZ)
            }
        }

        // 提前计算好开始的采样点和结束的采样点
        for (let i = 0; i <= canvasWidth; i += 4 * zoomX) {
            if (i > frameWidth && i <= canvasWidth) samplePerPage += 4 * zoomX * samplePerPixel
        }
        if (this.samples) {
            // ECG绘制
            if (this.samples.data1) {
                // 终止采样点
                endSample = startSample + samplePerPage
                // 如果采样点结束位置已经超出最大采样数，则限制采样范围
                if (endSample > sampleCount) {
                    startSample = sampleCount - samplePerPage
                    endSample = startSample + samplePerPage
                }
            }
        }
        DEBUG && console.log(TAG, `startSample:`, startSample)
        DEBUG && console.log(TAG, `endSample:`, endSample)
        let startCalc = startSample
        if (startCalc < this.headerSize) startCalc = this.headerSize
        DEBUG && console.log(TAG, `startCalc:`, startCalc)
        // 计算X坐标的取值范围，决定显示的纵坐标范围
        let rangeX = mathUtil.getRange(this.accXList, startCalc, endSample)
        DEBUG && console.log(TAG, `rangeX:\n`, rangeX)
        let rangeY = mathUtil.getRange(this.accYList, startCalc, endSample)
        DEBUG && console.log(TAG, `rangeY:\n`, rangeY)
        let rangeZ = mathUtil.getRange(this.accZList, startCalc, endSample)
        DEBUG && console.log(TAG, `rangeZ:\n`, rangeZ)

        // 计算滑块标尺
        this.state.marks = {}
        let stepTimes = this.state.max / 100
        for (let i = 0; i <= 10; i++) {
            let mark = i * 10 * stepTimes
            this.state.marks[mark] = Math.floor(mark * durationPerStep) + 's'
        }
        this.setState({ marks: this.state.marks })
        DEBUG && console.log(TAG, `this.state.marks:\n`, this.state.marks)

        // 绘制一块黑色背景
        const accXHeight = (accCanvasHeight - gapHeight * 2 - frameHeight * 2) / 3
        DEBUG && console.log(TAG, `accXHeight:`, accXHeight)
        ctx.fillStyle = "black"
        ctx.fillRect(0, 0, canvasWidth, accCanvasHeight)
        ctx.fillStyle = "white"
        ctx.fillRect(0, accXHeight + frameHeight, canvasWidth, gapHeight)
        ctx.fillRect(0, accXHeight * 2 + frameHeight + gapHeight, canvasWidth, gapHeight)
        // 绘制网格(黄线)
        ctx.strokeStyle = 'rgb(255,255,0)'
        // 横线
        // AccX
        const minYX = frameHeight
        for (let i = minYX; i <= minYX + accXHeight; i += 20) {
            let x1 = frameWidth, x2 = canvasWidth
            let y1 = i, y2 = i
            let lw = 0.2
            this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
        }
        let coordinateX = []
        let lenX = rangeX.max - rangeX.min
        let centerX = (rangeX.max + rangeX.min) / 2
        let coorMaxX = centerX + lenX * 4 / zoomY
        let coorMinX = centerX - lenX * 4 / zoomY
        for (let i = 0; i < 7; i++) {
            const numX = coorMaxX - i * (coorMaxX - coorMinX) / 6
            coordinateX.push(Math.round(numX * 10) / 10)
        }
        baseYX = frameHeight + accXHeight / 2
        let canvasRangeX = coorMaxX - coorMinX
        DEBUG && console.log(TAG, `coordinateX:\n`, coordinateX)
        // AccY
        const minYY = frameHeight + accXHeight + gapHeight
        for (let i = minYY; i <= minYY + accXHeight; i += 20) {
            let x1 = frameWidth, x2 = canvasWidth
            let y1 = i, y2 = i
            let lw = 0.2
            this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
        }
        let coordinateY = []
        let lenY = rangeY.max - rangeY.min
        let centerY = (rangeY.max + rangeY.min) / 2
        let coorMaxY = centerY + lenY * 4 / zoomY
        let coorMinY = centerY - lenY * 4 / zoomY
        for (let i = 0; i < 7; i++) {
            const numY = coorMaxY - i * (coorMaxY - coorMinY) / 6
            coordinateY.push(Math.round(numY * 10) / 10)
        }
        baseYY = minYY + accXHeight / 2
        let canvasRangeY = coorMaxY - coorMinY
        DEBUG && console.log(TAG, `coordinateY:\n`, coordinateY)
        // AccZ
        const minYZ = frameHeight + (accXHeight + gapHeight) * 2
        for (let i = minYZ; i <= minYZ + accXHeight; i += 20) {
            let x1 = frameWidth, x2 = canvasWidth
            let y1 = i, y2 = i
            let lw = 0.2
            this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
        }
        let coordinateZ = []
        let lenZ = rangeZ.max - rangeZ.min
        let centerZ = (rangeZ.max + rangeZ.min) / 2
        let coorMaxZ = centerZ + lenZ * 4 / zoomY
        let coorMinZ = centerZ - lenZ * 4 / zoomY
        for (let i = 0; i < 7; i++) {
            const numZ = coorMaxZ - i * (coorMaxZ - coorMinZ) / 6
            coordinateZ.push(Math.round(numZ * 10) / 10)
        }
        baseYZ = minYZ + accXHeight / 2
        let canvasRangeZ = coorMaxZ - coorMinZ
        DEBUG && console.log(TAG, `coordinateZ:\n`, coordinateZ)
        // 竖线(随着取样点的移动而移动)
        for (let i = 0; i <= canvasWidth; i += 4 * zoomX) {
            let x1 = i + colOffset + frameWidth
            let x2 = x1
            let y1 = frameHeight
            let y2 = accCanvasHeight - frameHeight

            let lw = 0
            if (i % (frameHeight * zoomX) === 0) {
                lw = 0.2
                if (i % (5 * frameHeight * zoomX) === 0) lw = 0.4
                this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
            }
            if (i > frameWidth && i <= canvasWidth - frameWidth) samplePerPage += 4 * zoomX * samplePerPixel
        }
        this.state.samplePerPage = samplePerPage
        this.setState({ samplePerPage: this.state.samplePerPage })
        if (this.samples) {
            if (this.samples.data2) {
                // console.log(TAG, `baseYX:`, baseYX)
                // console.log(TAG, `baseYY:`, baseYY)
                // console.log(TAG, `baseYZ:`, baseYZ)
                this.drawAccLine2(ctx, 'blue', this.accXList, baseYX, startSample, endSample, samplePerPixel, coorMinX, canvasRangeX)// AccX蓝线绘制
                this.drawAccLine2(ctx, 'red', this.accYList, baseYY, startSample, endSample, samplePerPixel, coorMinY, canvasRangeY)// AccY红线绘制
                this.drawAccLine2(ctx, 'green', this.accZList, baseYZ, startSample, endSample, samplePerPixel, coorMinZ, canvasRangeZ)// AccZ绿线绘制
            }
        }

        // 遮住左边
        ctx.fillStyle = "rgb(255,255,255)";
        ctx.fillRect(0, 0, frameWidth - 1, accCanvasHeight);
        // ctx.fillRect(canvasWidth - (frameWidth - 1), 0, frameWidth - 1, accCanvasHeight);
        // 遮住上边
        ctx.fillRect(0, 0, canvasWidth, frameHeight - 1);
        // 遮住下边
        ctx.fillRect(0, accCanvasHeight - (frameHeight - 1), canvasWidth, frameHeight - 1);
        for (let i = 0; i < xAnnotations.length; i++) {
            const annotation = xAnnotations[i];
            let x1 = annotation.x, x2 = annotation.x
            let y1 = accCanvasHeight - frameHeight - 3
            let y2 = accCanvasHeight - frameHeight + 8

            // 画一条绿色竖线
            ctx.fillStyle = 'green'
            ctx.strokeStyle = 'green'
            this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, 0.5 * zoomX)

            // 画横坐标(秒)
            ctx.fillStyle = 'black'
            ctx.strokeStyle = 'black'
            ctx.fillText(annotation.text, annotation.x, accCanvasHeight - frameHeight + 15)
        }
        // 绘制纵坐标
        // AccX
        for (let i = minYX; i <= minYX + accXHeight; i += 20) {
            const text = `${coordinateX[(i - minYX) / 20]}`
            const textWidth = ctx.measureText(text).width
            const x = frameWidth - 4 - textWidth
            ctx.fillText(text, x, i)
        }
        // AccY
        for (let i = minYY; i <= minYY + accXHeight; i += 20) {
            const text = `${coordinateY[(i - minYY) / 20]}`
            const textWidth = ctx.measureText(text).width
            const x = frameWidth - 4 - textWidth
            ctx.fillText(text, x, i)
        }
        // AccZ
        for (let i = minYZ; i <= minYZ + accXHeight; i += 20) {
            const text = `${coordinateZ[(i - minYZ) / 20]}`
            const textWidth = ctx.measureText(text).width
            const x = frameWidth - 4 - textWidth
            ctx.fillText(text, x, i)
        }

        // const x = canvasWidth - frameWidth + 4
        // ctx.fillText('X', x, baseYX)
        // ctx.fillText('Y', x, baseYY)
        // ctx.fillText('Z', x, baseYZ)
    }

    /** 绘制 ACC 图表(XYZ分开，并仅显示有效区域)(PC端) */
    drawAccChart2Pc() {
        const DEBUG = false
        const TAG = `EcgPage.drawAccChart2Pc() - `
        const { zoomX, zoomY, frameWidth, frameHeight, canvasWidth, accCanvasHeight, gapHeight, accChartHeight, accZPlusHeight } = this.state
        let canvas = document.getElementById('acc')
        if (!canvas.getContext) return
        var ctx = canvas.getContext("2d")

        const scale = 4
        // 计算采样显示相关数据
        let baseYX = 0
        let baseYY = 0
        let baseYZ = 0
        let samplePerPage = 0
        let sampleCount = 0
        let samplePerPixel = 1
        let samplePerStep = 0
        let durationPerStep = 0
        let startSample = 0
        let endSample = 0
        /** 列偏移量 */
        let xrayOffset = 0
        let xAnnotations = []
        if (this.samples) {
            if (this.samples.data1) {
                if (this.sampleList.length == 0) {
                    for (let i = 0; i < this.allSampleCnt; i++) {
                        this.sampleList.push(EMPTY_Y)
                    }
                }
                if (this.accXList.length == 0) {
                    for (let i = 0; i < this.headerSize; i++) {
                        this.accXList.push(0)
                    }
                    for (let i = 0; i < this.allSampleCnt; i++) {
                        this.accXList.push(EMPTY_Y)
                    }
                }
                if (this.accYList.length == 0) {
                    for (let i = 0; i < this.headerSize; i++) {
                        this.accYList.push(0)
                    }
                    for (let i = 0; i < this.allSampleCnt; i++) {
                        this.accYList.push(EMPTY_Y)
                    }
                }
                if (this.accZList.length == 0) {
                    for (let i = 0; i < this.headerSize; i++) {
                        this.accZList.push(0)
                    }
                    for (let i = 0; i < this.allSampleCnt; i++) {
                        this.accZList.push(EMPTY_Y)
                    }
                }
                this.rate = this.samples.data1.rate// 采样频率(个/秒)
                this.totalRecordTime = Math.ceil(this.allSampleCnt / this.rate)
                console.log(TAG, `记录总时长 totalRecordTime: ${this.totalRecordTime}秒`)
                let remoteStartPoint = this.samples.data1.startPoint// 返回数据的第一个在总数据中的索引
                let remoteList = this.samples.data1.list
                let remoteEndPoint = remoteStartPoint + remoteList.length
                // console.log(TAG, `remoteStartPoint:`, remoteStartPoint)
                // console.log(TAG, `remoteEndPoint:`, remoteEndPoint)
                for (let i = remoteStartPoint; i < remoteEndPoint; i++) {
                    this.sampleList[i] = remoteList[i - remoteStartPoint]
                }
                samplePerPixel = this.rate / 100
                sampleCount = this.sampleList.length
                // console.log(TAG, `sampleCount:`, sampleCount)
                samplePerStep = sampleCount / this.state.max
                durationPerStep = samplePerStep / this.rate
                // 开始采样点
                startSample = Math.round(this.state.step * samplePerStep)
                // let sampleOffset = this.rate - (startSample % this.rate)
                // if (sampleOffset == this.rate) sampleOffset = 0
                let sampleOffset = 0
                xrayOffset = 100 * sampleOffset / 512 * zoomX
                // colOffset = (startSample * 10 % (this.rate * 10 / 5)) * 5 / (this.rate * 10 / 5) * 4 * zoomX
                // console.log(TAG, `startSample:`, startSample)
                // console.log(TAG, `rate:`, this.rate)
                // console.log(TAG, `colOffset:`, colOffset)
                for (let i = 0; i < 11; i++) {
                    const x = xrayOffset + i * 4 * zoomX * 25 + frameWidth
                    const sampleCount = Math.round(startSample + i * this.rate)
                    const sampleSecond = Math.round(sampleCount / this.rate)
                    // const text = `${sampleCount}p`// 采样点数
                    // const text = `${sampleSecond}s`// 秒
                    const text = `${strUtil.formatDuration(sampleSecond)}`// 00:00:00
                    // console.log(`x:`, x)
                    // console.log(`text:`, text)
                    xAnnotations.push({ x: x, text: text })
                }

                this.state.samplePerSecond = this.rate
                this.setState({ samplePerSecond: this.state.samplePerSecond })
                this.state.samplePerJumpPage = this.rate * Math.floor(10 / zoomX)// 一页为10秒数据
                this.setState({ samplePerJumpPage: this.state.samplePerJumpPage })
                this.state.samplePerStep = samplePerStep
                this.setState({ samplePerStep: this.state.samplePerStep })
                this.state.sampleCount = sampleCount
                this.setState({ sampleCount: this.state.sampleCount })
            }
            if (this.samples.data2) {
                this.accRate = this.samples.data2.rate// 采样频率(个/秒)
                let accX = this.samples.data2.accX
                let accY = this.samples.data2.accY
                let accZ = this.samples.data2.accZ

                let remoteStartPoint = this.samples.data1.startPoint
                let blockStartId = Math.floor(remoteStartPoint / 4000)
                // console.log(`blockStartId:`, blockStartId)
                this.setAccData(remoteStartPoint, this.accXList, accX)
                this.setAccData(remoteStartPoint, this.accYList, accY)
                this.setAccData(remoteStartPoint, this.accZList, accZ)
            }
        }

        // 提前计算好开始的采样点和结束的采样点
        for (let i = 0; i <= canvasWidth; i += 4 * zoomX) {
            if (i > frameWidth && i <= canvasWidth - frameWidth) samplePerPage += 4 * zoomX * samplePerPixel
        }
        if (this.samples) {
            // ECG绘制
            if (this.samples.data1) {
                // 终止采样点
                endSample = startSample + samplePerPage
                // 如果采样点结束位置已经超出最大采样数，则限制采样范围
                if (endSample > sampleCount) {
                    startSample = sampleCount - samplePerPage
                    endSample = startSample + samplePerPage
                }
            }
        }
        DEBUG && console.log(TAG, `startSample:`, startSample)
        DEBUG && console.log(TAG, `endSample:`, endSample)
        let startCalc = startSample
        if (startCalc < this.headerSize) startCalc = this.headerSize
        DEBUG && console.log(TAG, `startCalc:`, startCalc)
        // 计算X坐标的取值范围，决定显示的纵坐标范围
        let rangeX = mathUtil.getRange(this.accXList, startCalc, endSample)
        DEBUG && console.log(TAG, `rangeX:\n`, rangeX)
        let rangeY = mathUtil.getRange(this.accYList, startCalc, endSample)
        DEBUG && console.log(TAG, `rangeY:\n`, rangeY)
        let rangeZ = mathUtil.getRange(this.accZList, startCalc, endSample)
        DEBUG && console.log(TAG, `rangeZ:\n`, rangeZ)

        // 计算滑块标尺
        this.state.marks = {}
        let stepTimes = this.state.max / 100
        for (let i = 0; i <= 10; i++) {
            let mark = i * 10 * stepTimes
            this.state.marks[mark] = Math.floor(mark * durationPerStep) + 's'
        }
        this.setState({ marks: this.state.marks })
        DEBUG && console.log(TAG, `this.state.marks:\n`, this.state.marks)

        // 绘制一块黑色背景
        const accXHeight = (accCanvasHeight - gapHeight * 2 - frameHeight * 2) / 3
        DEBUG && console.log(TAG, `accXHeight:`, accXHeight)
        ctx.fillStyle = "black"
        ctx.fillRect(0, 0, canvasWidth, accCanvasHeight)
        ctx.fillStyle = "white"
        ctx.fillRect(0, accXHeight + frameHeight, canvasWidth, gapHeight)
        ctx.fillRect(0, accXHeight * 2 + frameHeight + gapHeight, canvasWidth, gapHeight)
        // 绘制网格(黄线)
        ctx.strokeStyle = 'rgb(255,255,0)'
        // 横线
        // AccX
        const minYX = frameHeight
        for (let i = minYX; i <= minYX + accXHeight; i += 20) {
            let x1 = frameWidth, x2 = canvasWidth - frameWidth
            let y1 = i, y2 = i
            let lw = 0.2
            this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
        }
        let coordinateX = []
        let lenX = rangeX.max - rangeX.min
        let centerX = (rangeX.max + rangeX.min) / 2
        let coorMaxX = centerX + lenX * 4 / zoomY
        let coorMinX = centerX - lenX * 4 / zoomY
        for (let i = 0; i < 7; i++) {
            const numX = coorMaxX - i * (coorMaxX - coorMinX) / 6
            coordinateX.push(Math.round(numX * 10) / 10)
        }
        baseYX = frameHeight + accXHeight / 2
        let canvasRangeX = coorMaxX - coorMinX
        DEBUG && console.log(TAG, `coordinateX:\n`, coordinateX)
        // AccY
        const minYY = frameHeight + accXHeight + gapHeight
        for (let i = minYY; i <= minYY + accXHeight; i += 20) {
            let x1 = frameWidth, x2 = canvasWidth - frameWidth
            let y1 = i, y2 = i
            let lw = 0.2
            this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
        }
        let coordinateY = []
        let lenY = rangeY.max - rangeY.min
        let centerY = (rangeY.max + rangeY.min) / 2
        let coorMaxY = centerY + lenY * 4 / zoomY
        let coorMinY = centerY - lenY * 4 / zoomY
        for (let i = 0; i < 7; i++) {
            const numY = coorMaxY - i * (coorMaxY - coorMinY) / 6
            coordinateY.push(Math.round(numY * 10) / 10)
        }
        baseYY = minYY + accXHeight / 2
        let canvasRangeY = coorMaxY - coorMinY
        DEBUG && console.log(TAG, `coordinateY:\n`, coordinateY)
        // AccZ
        const minYZ = frameHeight + (accXHeight + gapHeight) * 2
        for (let i = minYZ; i <= minYZ + accXHeight; i += 20) {
            let x1 = frameWidth, x2 = canvasWidth - frameWidth
            let y1 = i, y2 = i
            let lw = 0.2
            this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
        }
        let coordinateZ = []
        let lenZ = rangeZ.max - rangeZ.min
        let centerZ = (rangeZ.max + rangeZ.min) / 2
        let coorMaxZ = centerZ + lenZ * 4 / zoomY
        let coorMinZ = centerZ - lenZ * 4 / zoomY
        for (let i = 0; i < 7; i++) {
            const numZ = coorMaxZ - i * (coorMaxZ - coorMinZ) / 6
            coordinateZ.push(Math.round(numZ * 10) / 10)
        }
        baseYZ = minYZ + accXHeight / 2
        let canvasRangeZ = coorMaxZ - coorMinZ
        DEBUG && console.log(TAG, `coordinateZ:\n`, coordinateZ)
        // 竖线(随着取样点的移动而移动)
        for (let i = -TOTAL_OFF; i <= canvasWidth - TOTAL_OFF; i += 4 * zoomX) {
            let x1 = i + xrayOffset + frameWidth + TOTAL_OFF
            let x2 = x1
            let y1 = frameHeight
            let y2 = accCanvasHeight - frameHeight

            let lw = 0
            if (i % (frameHeight * zoomX) === 0) {
                lw = 0.2
                if (i % (5 * frameHeight * zoomX) === 0) lw = 0.4
                this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
            }
            if (i > frameWidth && i <= canvasWidth - frameWidth) samplePerPage += 4 * zoomX * samplePerPixel
        }
        this.state.samplePerPage = samplePerPage
        this.setState({ samplePerPage: this.state.samplePerPage })
        if (this.samples) {
            if (this.samples.data2) {
                // console.log(TAG, `baseYX:`, baseYX)
                // console.log(TAG, `baseYY:`, baseYY)
                // console.log(TAG, `baseYZ:`, baseYZ)
                this.drawAccLine2(ctx, 'blue', this.accXList, baseYX, startSample, endSample, samplePerPixel, coorMinX, canvasRangeX)// AccX蓝线绘制
                this.drawAccLine2(ctx, 'red', this.accYList, baseYY, startSample, endSample, samplePerPixel, coorMinY, canvasRangeY)// AccY红线绘制
                this.drawAccLine2(ctx, 'green', this.accZList, baseYZ, startSample, endSample, samplePerPixel, coorMinZ, canvasRangeZ)// AccZ绿线绘制
            }
        }

        // 遮住左边和右边
        ctx.fillStyle = "rgb(255,255,255)";
        ctx.fillRect(0, 0, frameWidth - 1, accCanvasHeight);
        ctx.fillRect(canvasWidth - (frameWidth - 1), 0, frameWidth - 1, accCanvasHeight);
        // 遮住上边
        ctx.fillRect(0, 0, canvasWidth, frameHeight - 1);
        // 遮住下边
        ctx.fillRect(0, accCanvasHeight - (frameHeight - 1), canvasWidth, frameHeight - 1);
        for (let i = 0; i < xAnnotations.length; i++) {
            const annotation = xAnnotations[i];
            let x1 = annotation.x + TOTAL_OFF
            let x2 = x1
            let y1 = accCanvasHeight - frameHeight - 3
            let y2 = accCanvasHeight - frameHeight + 8

            // 画一条绿色竖线
            ctx.fillStyle = 'green'
            ctx.strokeStyle = 'green'
            this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, 0.5 * zoomX)

            // 画横坐标(秒)
            ctx.fillStyle = 'black'
            ctx.strokeStyle = 'black'
            ctx.fillText(annotation.text, x1, accCanvasHeight - frameHeight + 15)
        }
        // 绘制纵坐标
        // AccX
        for (let i = minYX; i <= minYX + accXHeight; i += 20) {
            const text = `${coordinateX[(i - minYX) / 20]}`
            const textWidth = ctx.measureText(text).width
            const x = frameWidth - 4 - textWidth
            ctx.fillText(text, x, i)
        }
        // AccY
        for (let i = minYY; i <= minYY + accXHeight; i += 20) {
            const text = `${coordinateY[(i - minYY) / 20]}`
            const textWidth = ctx.measureText(text).width
            const x = frameWidth - 4 - textWidth
            ctx.fillText(text, x, i)
        }
        // AccZ
        for (let i = minYZ; i <= minYZ + accXHeight; i += 20) {
            const text = `${coordinateZ[(i - minYZ) / 20]}`
            const textWidth = ctx.measureText(text).width
            const x = frameWidth - 4 - textWidth
            ctx.fillText(text, x, i)
        }

        // const x = canvasWidth - frameWidth + 4
        // ctx.fillText('X', x, baseYX)
        // ctx.fillText('Y', x, baseYY)
        // ctx.fillText('Z', x, baseYZ)
    }

    /** 绘制 ACC 图表 */
    drawAccChart() {
        const TAG = `EcgPage.drawAccChart() - `
        const { zoomX, zoomY, frameWidth, frameHeight, canvasWidth, accCanvasHeight, accChartHeight, accZPlusHeight } = this.state
        let canvas = document.getElementById('acc')
        if (!canvas.getContext) return
        var ctx = canvas.getContext("2d")

        const scale = 4
        // 计算采样显示相关数据
        let baseYX = 0
        let baseYY = 0
        let baseYZ = 0
        let samplePerPage = 0
        let sampleCount = 0
        let samplePerPixel = 1
        let samplePerStep = 0
        let durationPerStep = 0
        let startSample = 0
        let endSample = 0
        /** 列偏移量 */
        let colOffset = 0
        let xAnnotations = []
        if (this.samples) {
            if (this.samples.data1) {
                if (this.sampleList.length == 0) {
                    for (let i = 0; i < this.allSampleCnt; i++) {
                        this.sampleList.push(EMPTY_Y)
                    }
                }
                if (this.accXList.length == 0) {
                    for (let i = 0; i < this.headerSize; i++) {
                        this.accXList.push(0)
                    }
                    for (let i = 0; i < this.allSampleCnt; i++) {
                        this.accXList.push(EMPTY_Y)
                    }
                }
                if (this.accYList.length == 0) {
                    for (let i = 0; i < this.headerSize; i++) {
                        this.accYList.push(0)
                    }
                    for (let i = 0; i < this.allSampleCnt; i++) {
                        this.accYList.push(EMPTY_Y)
                    }
                }
                if (this.accZList.length == 0) {
                    for (let i = 0; i < this.headerSize; i++) {
                        this.accZList.push(0)
                    }
                    for (let i = 0; i < this.allSampleCnt; i++) {
                        this.accZList.push(EMPTY_Y)
                    }
                }
                this.rate = this.samples.data1.rate// 采样频率(个/秒)
                this.totalRecordTime = Math.ceil(this.allSampleCnt / this.rate)
                // console.log(TAG, `记录总时长 totalRecordTime: ${this.totalRecordTime}秒`)
                let remoteStartPoint = this.samples.data1.startPoint// 返回数据的第一个在总数据中的索引
                let remoteList = this.samples.data1.list
                let remoteEndPoint = remoteStartPoint + remoteList.length
                // console.log(TAG, `remoteStartPoint:`, remoteStartPoint)
                // console.log(TAG, `remoteEndPoint:`, remoteEndPoint)
                for (let i = remoteStartPoint; i < remoteEndPoint; i++) {
                    this.sampleList[i] = remoteList[i - remoteStartPoint]
                }
                samplePerPixel = this.rate / 100
                sampleCount = this.sampleList.length
                // console.log(TAG, `sampleCount:`, sampleCount)
                samplePerStep = sampleCount / this.state.max
                durationPerStep = samplePerStep / this.rate
                // 开始采样点
                startSample = Math.round(this.state.step * samplePerStep)
                let sampleOffset = this.rate - (startSample % this.rate)
                if (sampleOffset == this.rate) sampleOffset = 0
                colOffset = 100 * sampleOffset / 512 * zoomX
                // colOffset = (startSample * 10 % (this.rate * 10 / 5)) * 5 / (this.rate * 10 / 5) * 4 * zoomX
                // console.log(TAG, `startSample:`, startSample)
                // console.log(TAG, `rate:`, this.rate)
                // console.log(TAG, `colOffset:`, colOffset)
                for (let i = 0; i < 11; i++) {
                    const x = colOffset + i * 4 * zoomX * 25 + frameWidth
                    const sampleCount = Math.round(startSample + i * this.rate)
                    const sampleSecond = Math.round(sampleCount / this.rate)
                    // const text = `${sampleCount}p`// 采样点数
                    // const text = `${sampleSecond}s`// 秒
                    const text = `${strUtil.formatDuration(sampleSecond)}`// 00:00:00
                    // console.log(`x:`, x)
                    // console.log(`text:`, text)
                    xAnnotations.push({ x: x, text: text })
                }

                this.state.samplePerSecond = this.rate
                this.setState({ samplePerSecond: this.state.samplePerSecond })
                this.state.samplePerJumpPage = this.rate * Math.floor(10 / zoomX)// 一页为10秒数据
                this.setState({ samplePerJumpPage: this.state.samplePerJumpPage })
                this.state.samplePerStep = samplePerStep
                this.setState({ samplePerStep: this.state.samplePerStep })
                this.state.sampleCount = sampleCount
                this.setState({ sampleCount: this.state.sampleCount })
            }
            if (this.samples.data2) {
                this.accRate = this.samples.data2.rate// 采样频率(个/秒)
                let accX = this.samples.data2.accX
                let accY = this.samples.data2.accY
                let accZ = this.samples.data2.accZ

                let remoteStartPoint = this.samples.data1.startPoint
                let blockStartId = Math.floor(remoteStartPoint / 4000)
                // console.log(`blockStartId:`, blockStartId)
                this.setAccData(remoteStartPoint, this.accXList, accX)
                this.setAccData(remoteStartPoint, this.accYList, accY)
                this.setAccData(remoteStartPoint, this.accZList, accZ)
            }
        }
        // console.log(`xAnnotations:`, xAnnotations)
        // console.log(`sampleCount:`, sampleCount)
        // console.log(`samplePerStep:`, samplePerStep)
        // console.log(`durationPerStep:`, durationPerStep)
        // 计算滑块标尺
        this.state.marks = {}
        let stepTimes = this.state.max / 100
        for (let i = 0; i <= 10; i++) {
            let mark = i * 10 * stepTimes
            this.state.marks[mark] = Math.floor(mark * durationPerStep) + 's'
        }
        this.setState({ marks: this.state.marks })
        // console.log(TAG, `this.state.marks:\n`, this.state.marks)

        // 绘制一块黑色背景
        ctx.fillStyle = "black";
        ctx.fillRect(0, 0, canvasWidth, accCanvasHeight * zoomY);
        // 绘制网格(红线)
        ctx.strokeStyle = 'rgb(255,255,0)'
        // 横线
        baseYX = 100 + frameHeight
        baseYY = 200 + frameHeight
        baseYZ = 250 + frameHeight
        // const accHeight = (accChartHeight - accZPlusHeight) / 3
        for (let i = 0; i <= accChartHeight * zoomY; i += 25 * zoomY) {
            let x1 = frameWidth, x2 = canvasWidth - frameWidth
            let y1 = (i + frameHeight) * zoomY
            let y2 = (i + frameHeight) * zoomY

            let lw = 0.1
            if ([baseYX, baseYY, baseYZ].includes(y1)) lw = 0.4
            this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
        }
        // 竖线(随着取样点的移动而移动)
        for (let i = 0; i <= canvasWidth; i += 4 * zoomX) {
            let x1 = i + colOffset + frameWidth
            let x2 = x1
            let y1 = frameHeight
            let y2 = accCanvasHeight - frameHeight

            let lw = 0
            if (i % (frameHeight * zoomX) === 0) {
                lw = 0.1 * zoomX
                if (i % (5 * frameHeight * zoomX) === 0) lw = 0.2 * zoomX
                this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
            }
            if (i > frameWidth && i <= canvasWidth - frameWidth) samplePerPage += 4 * zoomX * samplePerPixel
        }
        this.state.samplePerPage = samplePerPage
        this.setState({ samplePerPage: this.state.samplePerPage })
        if (this.samples) {
            // ECG绘制
            if (this.samples.data1) {
                // 终止采样点
                endSample = startSample + samplePerPage
                // 如果采样点结束位置已经超出最大采样数，则限制采样范围
                if (endSample > sampleCount) {
                    startSample = sampleCount - samplePerPage
                    endSample = startSample + samplePerPage
                }
            }
            if (this.samples.data2) {
                this.drawAccLine(ctx, 'blue', this.accXList, baseYX, startSample, endSample, samplePerPixel)// AccX蓝线绘制
                this.drawAccLine(ctx, 'red', this.accYList, baseYY, startSample, endSample, samplePerPixel)// AccY红线绘制
                this.drawAccLine(ctx, 'green', this.accZList, baseYZ, startSample, endSample, samplePerPixel)// AccZ绿线绘制
            }
        }

        // 遮住左边和右边
        ctx.fillStyle = "rgb(255,255,255)";
        ctx.fillRect(0, 0, frameWidth - 1, accCanvasHeight);
        ctx.fillRect(canvasWidth - (frameWidth - 1), 0, frameWidth - 1, accCanvasHeight);
        // 遮住上边
        ctx.fillRect(0, 0, canvasWidth, frameHeight - 1);
        // 遮住下边
        ctx.fillRect(0, accCanvasHeight - (frameHeight - 1), canvasWidth, frameHeight - 1);
        for (let i = 0; i < xAnnotations.length; i++) {
            const annotation = xAnnotations[i];
            let x1 = annotation.x, x2 = annotation.x
            let y1 = accCanvasHeight - frameHeight - 3
            let y2 = accCanvasHeight - frameHeight + 8

            // 画一条绿色竖线
            ctx.fillStyle = 'green'
            ctx.strokeStyle = 'green'
            this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, 0.5 * zoomX)

            // 画横坐标(秒)
            ctx.fillStyle = 'black'
            ctx.strokeStyle = 'black'
            ctx.fillText(annotation.text, annotation.x, accCanvasHeight - frameHeight + 15)
        }
        // 绘制纵坐标
        const halfCharheight = 4
        for (let i = 0; i < 100 * scale; i += 100) {
            let actualY = i * this.gn8Rate
            const text = `${actualY}`
            const textWidth = ctx.measureText(text).width
            const x = frameWidth - 4 - textWidth
            ctx.fillText(text, x, baseYX - i / scale + halfCharheight)
            ctx.fillText(text, x, baseYY - i / scale + halfCharheight)
            if (i < 200) ctx.fillText(text, x, baseYZ - i / scale + halfCharheight)
            if (i >= 100) {
                const text = `-${actualY}`
                const textWidth = ctx.measureText(text).width
                const x = frameWidth - 4 - textWidth
                ctx.fillText(text, x, baseYZ + i / scale + halfCharheight)
            }
        }
        const x = canvasWidth - frameWidth + 4
        ctx.fillText('X', x, baseYX)
        ctx.fillText('Y', x, baseYY)
        ctx.fillText('Z', x, baseYZ)
    }

    /** 绘制 ECG 图表(移动端) */
    drawEcgChartMobile() {
        const t = this.props.trans
        const TAG = `EcgPage.drawEcgChartMobile() - `
        const { zoomX, zoomY, frameWidth, frameHeight, canvasWidth, ecgCanvasHeight: canvasHeight } = this.state
        let canvas = document.getElementById('heartBeat')
        if (!canvas.getContext) return
        var ctx = canvas.getContext("2d")

        // 计算采样显示相关数据
        let baseY1 = 0
        let samplePerPage = 0
        let sampleCount = 0
        let samplePerPixel = 1
        let samplePerStep = 0
        let durationPerStep = 0
        let startSample = 0
        let endSample = 0
        /** 列偏移量 */
        let colOffset = 0
        let xAnnotations = []
        if (this.samples) {
            if (this.samples.data1) {
                if (this.sampleList.length == 0) {
                    for (let i = 0; i < this.allSampleCnt; i++) {
                        this.sampleList.push(EMPTY_Y)
                    }
                }
                if (this.ihrList.length == 0) {
                    for (let i = 0; i < this.blockCnt; i++) {
                        this.ihrList.push(EMPTY_Y)
                    }
                }
                this.rate = this.samples.data1.rate// 采样频率(个/秒)
                this.totalRecordTime = Math.ceil(this.allSampleCnt / this.rate)
                console.log(TAG, `记录总时长 totalRecordTime: ${this.totalRecordTime}秒`)
                let remoteStartPoint = this.samples.data1.startPoint// 返回数据的第一个在总数据中的索引
                let remoteList = this.samples.data1.list
                if (remoteStartPoint == 0) {
                    // 计算滞后数量
                    let count = 0
                    for (let i = 0; i < remoteList.length; i++) {
                        const sample = remoteList[i];
                        if (sample == 0) count++
                        else break
                    }
                    this.headerSize = count
                    // console.log(TAG, `this.headerSize:`, this.headerSize)
                }
                let remoteEndPoint = remoteStartPoint + remoteList.length
                // console.log(TAG, `remoteStartPoint:`, remoteStartPoint)
                // console.log(TAG, `remoteEndPoint:`, remoteEndPoint)
                for (let i = remoteStartPoint; i < remoteEndPoint; i++) {
                    this.sampleList[i] = remoteList[i - remoteStartPoint]
                }
                samplePerPixel = this.rate / 100
                sampleCount = this.sampleList.length
                // console.log(TAG, `sampleCount:`, sampleCount)
                samplePerStep = sampleCount / this.state.max
                durationPerStep = samplePerStep / this.rate
                // 开始采样点
                startSample = Math.round(this.state.step * samplePerStep)
                let sampleOffset = this.rate - (startSample % this.rate)
                if (sampleOffset == this.rate) sampleOffset = 0
                colOffset = 100 * sampleOffset / 512 * zoomX
                // colOffset = (startSample * 10 % (this.rate * 10 / 5)) * 5 / (this.rate * 10 / 5) * 4 * zoomX
                // console.log(TAG, `startSample:`, startSample)
                // console.log(TAG, `rate:`, this.rate)
                // console.log(TAG, `colOffset:`, colOffset)
                for (let i = 0; i < 11; i++) {
                    const x = colOffset + i * 4 * zoomX * 25 + frameWidth
                    const sampleCount = Math.round(startSample + i * this.rate)
                    const sampleSecond = Math.round(sampleCount / this.rate)
                    // const text = `${sampleCount}p`// 采样点数
                    // const text = `${sampleSecond}s`// 秒
                    const text = `${strUtil.formatDuration(sampleSecond)}`// 00:00:00
                    // console.log(`x:`, x)
                    // console.log(`text:`, text)
                    xAnnotations.push({ x: x, text: text })
                }

                this.state.samplePerSecond = this.rate
                this.setState({ samplePerSecond: this.state.samplePerSecond })
                this.state.samplePerJumpPage = this.rate * Math.floor(10 / zoomX)// 一页为10秒数据
                this.setState({ samplePerJumpPage: this.state.samplePerJumpPage })
                this.state.samplePerStep = samplePerStep
                this.setState({ samplePerStep: this.state.samplePerStep })
                this.state.sampleCount = sampleCount
                this.setState({ sampleCount: this.state.sampleCount })
            }
            if (this.samples.data3) {
                const startBlockId = this.samples.data3.startBlockId
                const hrvData = this.samples.data3.hrv
                // console.log(`startBlockId:`, startBlockId)
                this.setHrvData(startBlockId, hrvData)
            }
        }
        // 计算滑块标尺
        this.state.marks = {}
        let stepTimes = this.state.max / 100
        for (let i = 0; i <= 10; i++) {
            let mark = i * 10 * stepTimes
            this.state.marks[mark] = Math.floor(mark * durationPerStep) + 's'
        }
        this.setState({ marks: this.state.marks })
        // console.log(TAG, `this.state.marks:\n`, this.state.marks)

        // 绘制一块白色背景
        ctx.fillStyle = "rgb(255,255,255)";
        ctx.fillRect(0, 0, canvasWidth, canvasHeight);
        // 绘制网格(红线)
        ctx.strokeStyle = 'red'
        // 横线
        for (let i = frameHeight; i <= canvasHeight; i += 4 * zoomY) {
            let x1 = frameWidth, x2 = canvasWidth
            let y1 = i
            let y2 = i

            let lw = 0
            if ((i - frameHeight) / (frameHeight * zoomY) === Math.ceil((canvasHeight - frameHeight) / (frameHeight * zoomY) / 2)) {
                lw = 0.4 * zoomX
                baseY1 = i
            }
            else if ((i - frameHeight) % (frameHeight * zoomY) === 0) lw = 0.2 * zoomX
            else lw = 0.1 * zoomX

            this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
        }
        // 竖线(随着取样点的移动而移动)
        for (let i = 0; i <= canvasWidth; i += 4 * zoomX) {
            let x1 = i + colOffset + 20
            let x2 = x1
            let y1 = frameHeight
            let y2 = canvasHeight - frameHeight

            let lw = 0
            // console.log(i % (frameHeight * zoomX))
            if (i % (frameHeight * zoomX) === 0) lw = 0.2 * zoomX
            else lw = 0.1 * zoomX

            this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
            if (i > frameHeight && i <= canvasWidth) samplePerPage += 4 * zoomX * samplePerPixel
        }
        this.state.samplePerPage = samplePerPage
        this.setState({ samplePerPage: this.state.samplePerPage })
        // 心跳曲线(毫安/0.04s) 25
        let data = []
        if (this.samples) {
            // ECG绘制
            if (this.samples.data1) {
                ctx.fillStyle = 'black'
                ctx.strokeStyle = 'black'
                // 终止采样点
                endSample = startSample + samplePerPage
                // 如果采样点结束位置已经超出最大采样数，则限制采样范围
                if (endSample > sampleCount) {
                    startSample = sampleCount - samplePerPage
                    endSample = startSample + samplePerPage
                }
                if (NO_DELAY) {
                    data = this.sampleList.slice(startSample, endSample + this.headerSize)
                }
                else {
                    data = this.sampleList.slice(startSample, endSample)
                }
                // console.log(TAG, `baseY: ${baseY}`)
                // console.log(TAG, `baseY1: ${baseY1}`)
                // console.log(TAG, `data.length: ${data.length}`)
                for (let i = 0; i < data.length - 1; i++) {
                    const dataIdx = i + (NO_DELAY ? this.headerSize : 0)
                    if (data[dataIdx] != EMPTY_Y && data[dataIdx + 1] != EMPTY_Y) {
                        let x1 = i * zoomX / samplePerPixel + frameWidth
                        let y1 = baseY1 - data[dataIdx] * 10 * 4 * zoomY
                        let x2 = (i + 1) * zoomX / samplePerPixel + frameWidth
                        let y2 = baseY1 - data[dataIdx + 1] * 10 * 4 * zoomY

                        // console.log(`start: x(${x1}), y(${y1})`)
                        this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, 0.5 * zoomX)
                    }
                }

                // 波峰圆点
                let circleList = []
                // console.log(`peekIndexList.length:`, this.peekIndexList.length)
                // console.log(`peekIndexList:\n`, this.peekIndexList)
                for (let i = 0; i < this.peekIndexList.length; i++) {
                    const peekIdx = this.peekIndexList[i]
                    if (NO_DELAY) {
                        if (peekIdx > startSample && peekIdx < endSample) {
                            circleList.push(peekIdx)
                        }
                    }
                    else {
                        if (peekIdx > startSample - this.headerSize && peekIdx < endSample) {
                            circleList.push(peekIdx + this.headerSize)// 加上偏移量
                        }
                    }
                }
                // console.log(`circleList:\n`, circleList)
                if (circleList.length > 0) {
                    for (let i = 0; i < circleList.length; i++) {
                        if (i > 0) {
                            if (circleList[i] - circleList[i - 1] < 100) console.error(TAG, `两个点很近:\n`, circleList)
                        }
                        const x = (circleList[i] - startSample) * zoomX / samplePerPixel + frameWidth
                        const y = baseY1 - 20
                        // console.log(`圆点: [${x}, ${y}]`)
                        this.drawPace(ctx, x, y)
                    }
                }
            }
        }


        // 遮住左边
        ctx.fillStyle = "rgb(255,255,255)";
        ctx.fillRect(0, 0, frameWidth - 1, canvasHeight);
        // ctx.fillRect(canvasWidth - (frameWidth - 1), 0, frameWidth - 1, canvasHeight);
        // 遮住上边
        ctx.fillRect(0, 0, canvasWidth, frameHeight - 1);
        // 遮住下边
        ctx.fillRect(0, canvasHeight - (frameHeight - 1), canvasWidth, frameHeight - 1);
        for (let i = 0; i < xAnnotations.length; i++) {
            const annotation = xAnnotations[i];
            let x1 = annotation.x, x2 = annotation.x
            let y1 = canvasHeight - frameHeight - 3
            let y2 = canvasHeight - frameHeight + 8

            // 画一条绿色竖线
            ctx.fillStyle = 'green'
            ctx.strokeStyle = 'green'
            this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, 0.5 * zoomX)

            // 画横坐标(秒)
            ctx.fillStyle = 'black'
            ctx.strokeStyle = 'black'
            ctx.fillText(annotation.text, annotation.x, canvasHeight - frameHeight + 15)
        }
        // 绘制纵坐标
        const halfCharheight = 4
        // console.log(`绘制纵坐标 - frameWidth:`, frameWidth)
        for (let i = 0; i < 120; i += 20 * zoomY) {
            const text = `${i / (40 * zoomY)}mV`
            const textWidth = ctx.measureText(text).width
            const x = frameWidth - 4 - textWidth
            // console.log(`绘制纵坐标 - x:`, x)
            ctx.fillText(text, x, baseY1 - i + halfCharheight)
            if (i > 0) {
                const text = `-${i / (40 * zoomY)}mV`
                const textWidth = ctx.measureText(text).width
                const x = frameWidth - 4 - textWidth
                ctx.fillText(text, x, baseY1 + i + halfCharheight)
            }
        }
    }

    /** 绘制 ECG 图表(PC端) */
    drawEcgChartPc() {
        const t = this.props.trans
        const TAG = `EcgPage.drawEcgChartPc() - `
        const { zoomX, zoomY, frameWidth, frameHeight, canvasWidth, ecgCanvasHeight: canvasHeight } = this.state
        let canvas = document.getElementById('heartBeat')
        if (!canvas.getContext) return
        var ctx = canvas.getContext("2d")

        // 计算采样显示相关数据
        let baseY1 = 0
        let samplePerPage = 0
        let sampleCount = 0
        let samplePerPixel = 1
        let samplePerStep = 0
        let durationPerStep = 0
        let startSampleIdx = 0
        let endSample = 0
        /** 列偏移量 */
        let xrayOffset = 0
        let xAnnotations = []
        if (this.samples) {
            if (this.samples.data1) {
                let flagList = this.samples.data1.flagList
                if (this.sampleList.length == 0) {
                    for (let i = 0; i < this.allSampleCnt; i++) {
                        this.sampleList.push(EMPTY_Y)
                        this.flagList.push(0)
                    }
                }
                if (this.ihrList.length == 0) {
                    for (let i = 0; i < this.blockCnt; i++) {
                        this.ihrList.push(EMPTY_Y)
                    }
                }
                this.rate = this.samples.data1.rate// 采样频率(个/秒)
                this.totalRecordTime = Math.ceil(this.allSampleCnt / this.rate)
                console.log(TAG, `记录总时长 totalRecordTime: ${this.totalRecordTime}秒`)
                let remoteStartPoint = this.samples.data1.startPoint// 返回数据的第一个在总数据中的索引
                let remoteList = this.samples.data1.list
                if (remoteStartPoint == 0) {
                    // 计算滞后数量
                    let count = 0
                    for (let i = 0; i < remoteList.length; i++) {
                        const sample = remoteList[i];
                        if (sample == 0) count++
                        else break
                    }
                    this.headerSize = count
                    // console.log(TAG, `this.headerSize:`, this.headerSize)
                }
                let remoteEndPoint = remoteStartPoint + remoteList.length
                // console.log(TAG, `remoteStartPoint:`, remoteStartPoint)
                // console.log(TAG, `remoteEndPoint:`, remoteEndPoint)
                for (let i = remoteStartPoint; i < remoteEndPoint; i++) {
                    this.sampleList[i] = remoteList[i - remoteStartPoint]
                    // 设置标记列表
                    this.flagList[i] = flagList[i - remoteStartPoint]
                }
                samplePerPixel = this.rate / 100
                sampleCount = this.allSampleCnt
                // console.log(TAG, `sampleCount:`, sampleCount)
                samplePerStep = sampleCount / this.state.max
                durationPerStep = samplePerStep / this.rate
                // 开始采样点
                startSampleIdx = Math.round(this.state.step * samplePerStep)
                // let sampleOffset = this.rate - (startSampleIdx % this.rate)
                // if (sampleOffset == this.rate) sampleOffset = 0
                let sampleOffset = 0
                xrayOffset = 100 * sampleOffset / 512 * zoomX

                console.log(TAG, `startSampleIdx:`, startSampleIdx)
                console.log(TAG, `sampleOffset:`, sampleOffset)
                console.log(TAG, `xrayOffset:`, xrayOffset)

                for (let i = 0; i < 11; i++) {
                    const x = xrayOffset + i * 4 * zoomX * 25 + frameWidth
                    const sampleCount = Math.round(startSampleIdx + i * this.rate)
                    const sampleSecond = Math.round(sampleCount / this.rate)
                    // const text = `${sampleCount}p`// 采样点数
                    // const text = `${sampleSecond}s`// 秒
                    const text = `${strUtil.formatDuration(sampleSecond)}`// 00:00:00
                    console.log(`x:`, x)
                    // console.log(`text:`, text)
                    // xAnnotations.push({ x: x, text: text })
                    xAnnotations.push({ x: x, text: `${i}S` })
                }

                this.state.samplePerSecond = this.rate
                this.setState({ samplePerSecond: this.state.samplePerSecond })
                this.state.samplePerJumpPage = this.rate * Math.floor(10 / zoomX)// 一页为10秒数据
                this.setState({ samplePerJumpPage: this.state.samplePerJumpPage })
                this.state.samplePerStep = samplePerStep
                this.setState({ samplePerStep: this.state.samplePerStep })
                this.state.sampleCount = sampleCount
                this.setState({ sampleCount: this.state.sampleCount })

                this.stepPerSecond = this.state.samplePerSecond / this.state.samplePerStep
                this.stepPerPage = this.state.samplePerJumpPage / this.state.samplePerStep
            }
            if (this.samples.data3) {
                const startBlockId = this.samples.data3.startBlockId
                const hrvData = this.samples.data3.hrv
                // console.log(`startBlockId:`, startBlockId)
                this.setHrvData(startBlockId, hrvData)
            }
        }
        // 计算滑块标尺
        this.state.marks = {}
        let stepTimes = this.state.max / 100
        for (let i = 0; i <= 10; i++) {
            let mark = i * 10 * stepTimes
            this.state.marks[mark] = Math.floor(mark * durationPerStep) + 's'
        }
        this.setState({ marks: this.state.marks })
        // console.log(TAG, `this.state.marks:\n`, this.state.marks)

        // 绘制一块白色背景
        ctx.fillStyle = "rgb(255,255,255)";
        ctx.fillRect(0, 0, canvasWidth, canvasHeight);
        // 绘制网格(红线)
        ctx.strokeStyle = 'red'
        // 横线
        for (let i = frameHeight; i <= canvasHeight - frameHeight; i += 4 * zoomY) {
            let x1 = frameWidth, x2 = canvasWidth - frameWidth
            let y1 = i
            let y2 = i

            let lw = 0
            if ((i - frameHeight) / (frameHeight * zoomY) === Math.ceil((canvasHeight - frameHeight) / (frameHeight * zoomY) / 2)) {
                lw = 0.4 * zoomX
                baseY1 = i
            }
            else if ((i - frameHeight) % (frameHeight * zoomY) === 0) lw = 0.2 * zoomX
            else lw = 0.1 * zoomX

            this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
        }
        // 竖线(随着取样点的移动而移动)
        for (let i = 0; i <= canvasWidth; i += 4 * zoomX) {
            let x1 = i + xrayOffset + 20
            let x2 = x1
            let y1 = frameHeight
            let y2 = canvasHeight - frameHeight

            let lw = 0
            // console.log(i % (frameHeight * zoomX))
            if (i % (frameHeight * zoomX) === 0) lw = 0.2 * zoomX
            else lw = 0.1 * zoomX

            this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
            if (i > frameHeight && i <= canvasWidth - frameHeight) samplePerPage += 4 * zoomX * samplePerPixel
        }
        this.state.samplePerPage = samplePerPage
        this.setState({ samplePerPage: this.state.samplePerPage })
        // 心跳曲线(毫安/0.04s) 25
        let data = []
        let flagData = []
        const gridSmallWidth = 4 // 每小格的像素数宽度
        const gridBigWidth = gridSmallWidth * 5 // 每大格的像素数宽度
        const gridSmallHeight = 4 // 每小格的像素数高度
        const gridBigHeight = gridSmallHeight * 5 // 每大格的像素数高度
        const unit = this.state.unit == 0 ? .5 : 1
        if (this.samples) {
            // ECG绘制
            if (this.samples.data1) {

                // 1. 数据生成
                // 终止采样点
                endSample = startSampleIdx + samplePerPage
                // 如果采样点结束位置已经超出最大采样数，则限制采样范围
                if (endSample > sampleCount) {
                    startSampleIdx = sampleCount - samplePerPage
                    endSample = startSampleIdx + samplePerPage
                }
                if (NO_DELAY) {
                    data = this.sampleList.slice(startSampleIdx, endSample + this.headerSize)
                    flagData = this.flagList.slice(startSampleIdx, endSample + this.headerSize)
                }
                else {
                    data = this.sampleList.slice(startSampleIdx, endSample)
                    flagData = this.flagList.slice(startSampleIdx, endSample)
                }
                // console.log(TAG, `baseY: ${baseY}`)
                // console.log(TAG, `baseY1: ${baseY1}`)
                // console.log(TAG, `data.length: ${data.length}`)

                // 2. 数据绘制
                // (1) 异常区域
                const grayY = frameHeight
                let abnormalStartX = 0
                let abnormalEndX = 0
                for (let i = 0; i < flagData.length; i++) {
                    let drawRect = false
                    if ((i == 0 && (0b10 & flagData[i]) != 0)
                        || (i > 0 && (0b10 & flagData[i]) != 0 && (0b10 & flagData[i - 1]) == 0)) {
                        abnormalStartX = i * zoomX / samplePerPixel + frameWidth + TOTAL_OFF
                    }
                    if (i > 0 && (0b10 & flagData[i]) == 0 && (0b10 & flagData[i - 1]) != 0) {
                        drawRect = true
                    }
                    if (i == flagData.length - 1 && (0b10 & flagData[i]) != 0) {
                        drawRect = true
                    }
                    if (drawRect) {
                        abnormalEndX = i * zoomX / samplePerPixel + frameWidth + TOTAL_OFF
                        if (abnormalEndX > canvasWidth - frameWidth) abnormalEndX = canvasWidth - frameWidth
                        this.drawGray(ctx, abnormalStartX, grayY, abnormalEndX - abnormalStartX, 20 * 11, 1)
                    }
                }

                // (2) 绘制 ECG 曲线
                ctx.fillStyle = 'black'
                ctx.strokeStyle = 'black'
                for (let i = 0; i < data.length - 1; i++) {
                    const dataIdx = i + (NO_DELAY ? this.headerSize : 0)
                    if (dataIdx && data[dataIdx] != EMPTY_Y && data[dataIdx + 1] != EMPTY_Y) {
                        let x1 = i * zoomX / samplePerPixel + frameWidth + TOTAL_OFF
                        let y1 = baseY1 - data[dataIdx] * 10 * 4 * zoomY
                        let x2 = (i + 1) * zoomX / samplePerPixel + frameWidth + TOTAL_OFF
                        let y2 = baseY1 - data[dataIdx + 1] * 10 * 4 * zoomY

                        // console.log(`start: x(${x1}), y(${y1})`)
                        this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, 0.5 * zoomX)
                    }
                }

                // (3) 绘制 PACE
                const paceY = baseY1 - 20   // pace 图案 Y 位置
                let paceStartX = 0
                let paceEndX = 0
                for (let i = 0; i < flagData.length; i++) {
                    if ((i == 0 && (0b01 & flagData[i]) != 0)
                        || (i > 0 && (0b01 & flagData[i]) != 0 && (0b01 & flagData[i - 1]) == 0)) {
                        paceStartX = i * zoomX / samplePerPixel + frameWidth + TOTAL_OFF
                    }
                    if (i > 0 && (0b01 & flagData[i]) == 0 && (0b01 & flagData[i - 1]) != 0) {
                        paceEndX = i * zoomX / samplePerPixel + frameWidth + TOTAL_OFF
                        this.drawPace2(ctx, paceStartX, paceY, paceEndX - paceStartX)
                    }
                }

                // 波峰圆点
                let circleList = []
                // console.log(`peekIndexList.length:`, this.peekIndexList.length)
                // console.log(`peekIndexList:\n`, this.peekIndexList)
                for (let i = 0; i < this.peekIndexList.length; i++) {
                    const peekIdx = this.peekIndexList[i]
                    if (NO_DELAY) {
                        if (peekIdx > startSampleIdx && peekIdx < endSample) {
                            circleList.push(peekIdx)
                        }
                    }
                    else {
                        if (peekIdx > startSampleIdx - this.headerSize && peekIdx < endSample) {
                            circleList.push(peekIdx + this.headerSize)// 加上偏移量
                        }
                    }
                }
                // console.log(`circleList:\n`, circleList)
                if (circleList.length > 0) {
                    for (let i = 0; i < circleList.length; i++) {
                        if (i > 0) {
                            if (circleList[i] - circleList[i - 1] < 100) console.error(TAG, `两个点很近:\n`, circleList)
                        }
                        const x = (circleList[i] - startSampleIdx) * zoomX / samplePerPixel + frameWidth + TOTAL_OFF
                        const y = baseY1 - 20
                        // console.log(`圆点: [${x}, ${y}]`)
                        this.drawPace(ctx, x, y)
                    }
                }
            }
        }

        // 绘制增益图案
        ctx.fillStyle = 'black'
        ctx.strokeStyle = 'black'
        const GAIN_SIZE = {
            HEIGHT: gridBigWidth * 2,
            GAIN_LINE_WIDTH: 2,
            POINT_ARRAY: [
                { x: 0, y: 0 },
                { x: gridSmallWidth * 2, y: 0 },
                { x: gridSmallWidth * 2, y: gridBigHeight * 2 * unit },
                { x: gridSmallWidth * 6, y: gridBigHeight * 2 * unit },
                { x: gridSmallWidth * 6, y: 0 },
                { x: gridSmallWidth * 8, y: 0 },
            ],
            BASE_X: frameWidth + gridSmallWidth,
            BASE_Y: baseY1 - gridSmallHeight,
            TEXT_X: frameWidth + gridSmallWidth + gridSmallHeight * 9,
            TEXT_Y: baseY1 - gridSmallHeight * unit * 7,
        }
        let lw = GAIN_SIZE.GAIN_LINE_WIDTH
        for (let i = 0; i < GAIN_SIZE.POINT_ARRAY.length - 1; i++) {
            let x1 = GAIN_SIZE.BASE_X + GAIN_SIZE.POINT_ARRAY[i].x
            let y1 = GAIN_SIZE.BASE_Y - GAIN_SIZE.POINT_ARRAY[i].y
            let x2 = GAIN_SIZE.BASE_X + GAIN_SIZE.POINT_ARRAY[i + 1].x
            let y2 = GAIN_SIZE.BASE_Y - GAIN_SIZE.POINT_ARRAY[i + 1].y

            this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
        }
        const textHeight = 10 * unit
        this.drawLine(ctx,
            { x: GAIN_SIZE.TEXT_X, y: GAIN_SIZE.TEXT_Y },
            { x: GAIN_SIZE.TEXT_X, y: GAIN_SIZE.TEXT_Y - textHeight },
            lw)
        this.drawLine(ctx,
            { x: GAIN_SIZE.TEXT_X + 5, y: GAIN_SIZE.TEXT_Y },
            { x: GAIN_SIZE.TEXT_X + 5, y: GAIN_SIZE.TEXT_Y - textHeight },
            lw)

        // 遮住左边和右边
        ctx.fillStyle = "rgb(255,255,255)";
        ctx.fillRect(0, 0, frameWidth - 1, canvasHeight);
        ctx.fillRect(canvasWidth - (frameWidth - 1), 0, frameWidth - 1, canvasHeight);
        // 遮住上边
        ctx.fillRect(0, 0, canvasWidth, frameHeight - 1);
        // 遮住下边
        ctx.fillRect(0, canvasHeight - (frameHeight - 1), canvasWidth, frameHeight - 1);
        for (let i = 0; i < xAnnotations.length; i++) {
            const annotation = xAnnotations[i];
            let x1 = annotation.x + TOTAL_OFF
            let x2 = x1
            let y1 = canvasHeight - frameHeight - 3
            let y2 = canvasHeight - frameHeight + 8

            // 画一条绿色竖线
            ctx.fillStyle = 'green'
            ctx.strokeStyle = 'green'
            this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, 0.5 * zoomX)

            // 画横坐标(秒)
            ctx.fillStyle = 'black'
            ctx.strokeStyle = 'black'
            ctx.fillText(annotation.text, x1, canvasHeight - frameHeight + 15)
        }
        // 绘制纵坐标
        const halfCharheight = 4
        // console.log(`绘制纵坐标 - frameWidth:`, frameWidth)
        for (let i = 0; i < 120; i += 20 * zoomY) {
            const text = `${i / (40 * zoomY)}mV`
            const textWidth = ctx.measureText(text).width
            const x = frameWidth - 4 - textWidth
            // console.log(`绘制纵坐标 - x:`, x)
            ctx.fillText(text, x, baseY1 - i + halfCharheight)
            if (i > 0) {
                const text = `-${i / (40 * zoomY)}mV`
                const textWidth = ctx.measureText(text).width
                const x = frameWidth - 4 - textWidth
                ctx.fillText(text, x, baseY1 + i + halfCharheight)
            }
        }
        // 绘制当前图表0刻度位置的绝对时间
        if (this.startTime > 0) {
            const TIME = {
                x: frameWidth,
                y: frameHeight - 2,
                startTime: this.getPdfStartTime(this.startTime)
            }
            const font = `${ctx.font}`
            ctx.font = `14px Arial`
            ctx.fillText(TIME.startTime, TIME.x, TIME.y)
            ctx.font = font
        }
    }

    getPdfStartTime = (startTimestamp) => {
        const pdfTimestamp = startTimestamp + this.timeSecond
        return timeUtil.formatTime(pdfTimestamp, 'YYYY-MM-DD HH:mm:ss.SSS')
    }

    /** 绘制线条. */
    drawLine = (ctx, p1, p2, lw) => {
        ctx.beginPath()
        ctx.moveTo(p1.x, p1.y)
        ctx.lineTo(p2.x, p2.y)
        ctx.closePath()
        ctx.lineWidth = lw
        ctx.stroke()
    }

    drawPace = (ctx, x, y) => {
        // this.drawArc(ctx, x, y, 5)
        ctx.fillStyle = 'red'
        ctx.strokeStyle = 'red'
        ctx.beginPath()
        ctx.moveTo(x, y)
        ctx.lineTo(x, y + 10)
        ctx.closePath()
        ctx.lineWidth = 5
        ctx.stroke()
    }

    drawPace2 = (ctx, x, y, w) => {
        ctx.fillStyle = 'red'
        ctx.strokeStyle = 'red'
        ctx.fillRect(x, y, w, 10)
        ctx.strokeRect(x, y, w, 10)
    }

    /** 绘制灰色异常区域 */
    drawGray = (ctx, x, y, w, h, scale) => {
        let t = this.props.trans;
        ctx.fillStyle = 'rgba(192, 192, 192, 0.3)' // 半透明灰色
        ctx.strokeStyle = 'rgba(192, 192, 192, 0.3)' // 半透明灰色
        ctx.beginPath()
        ctx.fillRect(x, y, w, h)
        ctx.strokeRect(x, y, w, h)
        let font = `${ctx.font}`
        ctx.font = `12px Arial`
        ctx.fillStyle = 'rgba(255, 0, 0)'
        ctx.strokeStyle = 'rgba(255, 0, 0)'
        const text = t('signal_disturbance')
        const textWidth = ctx.measureText(text).width
        const textX = x + (w - textWidth) / 2
        ctx.fillText(text, textX, y + 60)
        ctx.font = font
    }

    drawArc = (ctx, x, y, r) => {
        ctx.fillStyle = 'green'
        ctx.strokeStyle = 'green'
        ctx.beginPath()
        ctx.arc(x, y, r, 0, Math.PI * 2)
        ctx.closePath()
        ctx.fill()
    }

    /** 处理X轴方向上的放大缩小变化. */
    onZoomXChange = (event) => {
        console.log(`event.target.text:`, event.target.text)
        this.state.zoomX = parseInt(event.target.text)
        this.setState({ zoomX: this.state.zoomX })
        this.draw()
    }

    /** 处理Y轴方向上的放大缩小变化. */
    onZoomYChange = (event) => {
        this.state.zoomY = parseInt(event.target.text)
        this.setState({ zoomY: this.state.zoomY })
        this.draw()
    }

    showUserDetail = (target) => {
        const attrList = []
        for (let i = this.userInfo.length - 1; i >= 0; i--) {
            const e = this.userInfo[i]
            attrList.push({
                trName: `trUser${i}`,
                trTitle: e.key,
                trValue: e.val
            })
        }
        componentUtil.showTable(2, target, this.userInfo, attrList)
    }

    showDeviceDetail = (target) => {
        const attrList = []
        for (let i = this.deviceInfo.length - 1; i >= 0; i--) {
            const e = this.deviceInfo[i]
            attrList.push({
                trName: `trDevice${i}`,
                trTitle: e.key,
                trValue: e.val
            })
        }
        componentUtil.showTable(2, target, this.deviceInfo, attrList)
    }

    showDataDetail = (target) => {
        const attrList = []
        for (let i = this.dataInfo.length - 1; i >= 0; i--) {
            const e = this.dataInfo[i]
            attrList.push({
                trName: `trData${i}`,
                trTitle: e.key,
                trValue: e.val
            })
        }
        componentUtil.showTable(2, target, this.dataInfo, attrList)
    }

    showBlockDetail = (target) => {
        const attrList = []
        for (let i = this.state.blockInfo.length - 1; i >= 0; i--) {
            const e = this.state.blockInfo[i]
            attrList.push({
                trName: `trBlock${i}`,
                trTitle: e.key,
                trValue: e.val
            })
        }
        componentUtil.showTable(2, target, this.state.blockInfo, attrList)
    }

    // =============================================================================
    // 渲染界面
    // =============================================================================
    render() {
        if (Global.isMobile) return this.renderMobile()
        else return this.renderPc()
    }

    renderMobile() {
        let t = this.props.trans
        const { step } = this.state;
        return (
            < div style={{ width: `${Global.windowWidth}px` }}>
                {/** 信息区1(使用者信息) */}
                <table className="table table-bordered table-striped mb-none">
                    <thead>
                        <tr>
                            <th style={{ width: '20px' }}><i data-toggle class="fa fa-caret-down text-primary h5 m-none" style={{ cursor: 'pointer' }} onClick={(e) => { this.showUserDetail(e.target) }}></i></th>
                            <th><font color="blue">{t('userInfo')}</font></th>
                        </tr>
                    </thead>
                </table>
                {/** 信息区1(设备信息) */}
                <table className="table table-bordered table-striped mb-none">
                    <thead>
                        <tr>
                            <th style={{ width: '20px' }}><i data-toggle class="fa fa-caret-down text-primary h5 m-none" style={{ cursor: 'pointer' }} onClick={(e) => { this.showDeviceDetail(e.target) }}></i></th>
                            <th><font color="blue">{t('deviceInfo')}</font></th>
                        </tr>
                    </thead>
                </table>
                {/** 信息区1(数据信息) */}
                <table className="table table-bordered table-striped mb-none" style={{ "table-layout": "fixed", width: `${Global.windowWidth}px` }}>
                    <thead>
                        <tr>
                            <th style={{ width: '24.8px' }}><i data-toggle class="fa fa-caret-down text-primary h5 m-none" style={{ cursor: 'pointer' }} onClick={(e) => { this.showDataDetail(e.target) }}></i></th>
                            <th><font color="blue">{t('dataInfo')}</font></th>
                        </tr>
                    </thead>
                </table>
                {/** 信息区2(块信息) */}
                <table className="table table-bordered table-striped mb-none">
                    <thead>
                        <tr>
                            <th style={{ width: '20px' }}><i data-toggle class="fa fa-caret-down text-primary h5 m-none" style={{ cursor: 'pointer' }} onClick={(e) => { this.showBlockDetail(e.target) }}></i></th>
                            <th><font color="blue">{t('blockInfo')}</font></th>
                        </tr>
                    </thead>
                </table>
                {/** 画布控制区 */}
                {/* < div id="canvasCtrl" >
                        <h1>
                            <div className="btn-group">
                                <button style={{ width: '200px' }} type="button"
                                    className="mb-lg mt-lg mr-lg btn btn-default dropdown-toggle"
                                    data-toggle="dropdown"><h1>{this.state.zoomX}</h1><span className="caret"></span></button>
                                <ul className="dropdown-menu" role="menu">
                                    {DEFAULT_ZOOM.map((item, index) => (
                                        <li key={index}><a onClick={this.onZoomXChange}><h1>{item}</h1></a></li>
                                    ))}
                                </ul>
                            </div>
                            <label>{t('zoom')}X .</label>

                            <div className="btn-group">
                                <button style={{ width: '200px' }} type="button"
                                    className="mb-xs mt-xs mr-xs btn btn-default dropdown-toggle"
                                    data-toggle="dropdown"> {this.state.zoomY} <span className="caret"></span></button>
                                <ul className="dropdown-menu" role="menu">
                                    {DEFAULT_ZOOM.map((item, index) => (
                                        <li key={index}><a onClick={this.onZoomYChange}>{item}</a></li>
                                    ))}
                                </ul>
                            </div>
                            <label>{t('zoom')}Y .</label>
                        </h1>
                    </div > */}
                {/** 加载提示区 */}
                <div>
                    {this.state.showLoading && <div><h1><font color="red">{t('loading')}</font></h1></div>}
                </div>
                <div className="row">
                    {/** 画布区 */}
                    <div className="acc" style={{ display: this.state.showAcc ? 'block' : 'none' }}>
                        <canvas id="acc" width={this.state.canvasWidth} height={this.state.accCanvasHeight} />
                    </div>
                </div>
                <div className="row">
                    <div className="heartBeat">
                        <canvas id="heartBeat" width={this.state.canvasWidth} height={this.state.ecgCanvasHeight} />
                    </div>
                </div>
                {/** 画布浏览区 */}
                {/** 拖动滑块区 */}
                {/* <div className="row" style={{ 'text-align': 'center' }}>
                    <Slider
                        max={this.state.max}
                        marks={this.state.marks}
                        value={Math.round(step)}
                        onChange={this.handleChange} />
                </div> */}
                <div className="row" style={{ 'text-align': 'center' }}>
                    {/** 左侧控制区(跳转第一页，向前一页，向前一秒) */}
                    <ul className="pagination">
                        <li key="first_page">
                            <a href="javascript:void(0)" onClick={this.firstPage}>
                                |<span className="fa fa-chevron-left"></span>
                            </a>
                        </li>
                        <li key="prev_page">
                            <a href="javascript:void(0)" onClick={this.prevPage}>
                                P<span className="fa fa-chevron-left"></span>
                            </a>
                        </li>
                        <li key="prev_second">
                            <a href="javascript:void(0)" onClick={this.prevSecond}>
                                S<span className="fa fa-chevron-left"></span>
                            </a>
                        </li>
                    </ul>

                    {/** 右侧控制区(跳转最后一页，向后一页，向后一秒) */}
                    <ul className="pagination">
                        <li key="next_second">
                            <a href="javascript:void(0)" onClick={this.nextSecond}>
                                <span className="fa fa-chevron-right">S</span>
                            </a>
                        </li>
                        <li key="next_page">
                            <a href="javascript:void(0)" onClick={this.nextPage}>
                                <span className="fa fa-chevron-right">P</span>
                            </a>
                        </li>
                        <li key="last_page">
                            <a href="javascript:void(0)" onClick={this.lastPage}>
                                <span className="fa fa-chevron-right">|</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div >
        )
    }

    renderPc() {
        let t = this.props.trans
        const { step } = this.state;
        return (
            < div className="panel-body" >
                <div className="col-md-2 col-lg-2 col-xl-2">
                    {/** 信息区1(使用者信息) */}
                    <table className="table table-bordered table-striped mb-none">
                        <thead>
                            <tr>
                                <th colSpan={2}><font color="blue">{t('userInfo')}</font></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.userInfo.map((item, index) => (
                                <tr key={index}>
                                    <td><strong>{item.key}</strong>: {item.val}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {/** 信息区1(设备信息) */}
                    <table className="table table-bordered table-striped mb-none" style={{ "table-layout": "fixed" }}>
                        <thead>
                            <tr>
                                <th><font color="blue">{t('deviceInfo')}</font></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.deviceInfo.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ "word-wrap": "break-word" }}><strong>{item.key}</strong>: {item.val}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {/** 信息区1(数据信息) */}
                    <table className="table table-bordered table-striped mb-none" style={{ "table-layout": "fixed" }}>
                        <thead>
                            <tr>
                                <th><font color="blue">{t('dataInfo')}</font></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.dataInfo.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ "word-wrap": "break-word" }}><strong>{item.key}</strong>: {item.val}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {/** 信息区2(块信息) */}
                    <table className="table table-bordered table-striped mb-none">
                        <thead>
                            <tr>
                                <th colSpan={2}><font color="blue">{t('blockInfo')}</font></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.blockInfo.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ wordWrap: "break-word" }}><strong>{item.key}</strong>: {item.val}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {/** 画布控制区 */}
                    < div id="canvasCtrl" >
                        <div className='row canvas-ctrl'>
                            <div className="btn-group">
                                <button style={{ width: '50px' }} type="button"
                                    className="mb-xs mt-xs mr-xs btn btn-default dropdown-toggle"
                                    data-toggle="dropdown"> {this.state.zoomX} <span className="caret"></span></button>
                                <ul className="dropdown-menu" role="menu">
                                    {DEFAULT_ZOOM.map((item, index) => (
                                        <li key={index}><a onClick={this.onZoomXChange}>{item}</a></li>
                                    ))}
                                </ul>
                            </div>
                            <label>{t('zoom')}X .</label>

                            <div className="btn-group">
                                <button style={{ width: '50px' }} type="button"
                                    className="mb-xs mt-xs mr-xs btn btn-default dropdown-toggle"
                                    data-toggle="dropdown"> {this.state.zoomY} <span className="caret"></span></button>
                                <ul className="dropdown-menu" role="menu">
                                    {DEFAULT_ZOOM.map((item, index) => (
                                        <li key={index}><a onClick={this.onZoomYChange}>{item}</a></li>
                                    ))}
                                </ul>
                            </div>
                            <label>{t('zoom')}Y .</label>
                        </div>
                        <div className='row canvas-ctrl'>
                            {t('tipZoomX')}
                        </div>
                        <div className='row canvas-ctrl'>
                            {t('tipZoomY')}
                        </div>
                    </div >
                    {/** 加载提示区 */}
                    <div>
                        {this.state.showLoading && <div><h1><font color="red">{t('loading')}</font></h1></div>}
                    </div>
                </div>
                <div className="col-md-9 col-lg-9 col-xl-9">
                    {/** 画布区 */}
                    <div className="acc" style={{ display: this.state.showAcc ? 'block' : 'none' }}>
                        <canvas id="acc" width={this.state.canvasWidth} height={this.state.accCanvasHeight} />
                    </div>
                    <div className="heartBeat">
                        <canvas id="heartBeat" width={this.state.canvasWidth} height={this.state.ecgCanvasHeight} />
                    </div>
                    {/** 画布浏览区 */}
                    <div className="row">
                        {/** 左侧控制区(跳转第一页，向前一页，向前一秒) */}
                        <div className="col-md-2">
                            <ul className="pagination">
                                <li key="first_page">
                                    <a href="javascript:void(0)" onClick={this.firstPage}>
                                        |<span className="fa fa-chevron-left"></span>
                                    </a>
                                </li>
                                <li key="prev_page">
                                    <a href="javascript:void(0)" onClick={this.prevPage}>
                                        P<span className="fa fa-chevron-left"></span>
                                    </a>
                                </li>
                                <li key="prev_second">
                                    <a href="javascript:void(0)" onClick={this.prevSecond}>
                                        S<span className="fa fa-chevron-left"></span>
                                    </a>
                                </li>
                            </ul>
                        </div>

                        {/** 拖动滑块区 */}
                        <div className="col-md-8">
                            <Slider
                                max={this.state.max}
                                marks={this.state.marks}
                                value={Math.round(step)}
                                onChange={this.handleChange} />
                        </div>

                        {/** 右侧控制区(跳转最后一页，向后一页，向后一秒) */}
                        <div className="col-md-2">
                            <ul className="pagination">
                                <li key="next_second">
                                    <a href="javascript:void(0)" onClick={this.nextSecond}>
                                        <span className="fa fa-chevron-right">S</span>
                                    </a>
                                </li>
                                <li key="next_page">
                                    <a href="javascript:void(0)" onClick={this.nextPage}>
                                        <span className="fa fa-chevron-right">P</span>
                                    </a>
                                </li>
                                <li key="last_page">
                                    <a href="javascript:void(0)" onClick={this.lastPage}>
                                        <span className="fa fa-chevron-right">|</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}